import { SignInFailedPayloadSchema, SignInSucceededPayloadSchema, SignOutPayloadSchema } from './identity-auth.events';
import {
  ActingMemberToolCalledPayloadSchema,
  AdminSignInFailedPayloadSchema,
  AdminSignInSucceededPayloadSchema,
  AdminSignOutPayloadSchema,
} from './identity-admin.events';
import {
  AccessDeniedPayloadSchema,
  AccessGrantedPayloadSchema,
  AccessUnauthenticatedPayloadSchema,
  McpAccessSwitchChangedPayloadSchema,
  WorkspaceMcpSwitchChangedPayloadSchema,
  McpToolExposureChangedPayloadSchema,
  McpToolExposureStaleEntryRemovedPayloadSchema,
} from './identity-access.events';
import {
  ValuationAgentTokenIssuedPayloadSchema,
  ValuationAgentTokenReplacedPayloadSchema,
  ValuationAgentTokenRevokedPayloadSchema,
} from './identity-valuation-agent-tokens.events';
import {
  WorkspaceCreatedPayloadSchema,
  WorkspaceLinkedToHlrePayloadSchema,
  WorkspaceWebAddressChangedPayloadSchema,
} from './identity-workspace.events';
import {
  ActivityRecordedPayloadSchema,
  ActivityCompletedPayloadSchema,
  ActivityRescheduledPayloadSchema,
  ActivityUpdatedPayloadSchema,
  ActivityCancelledPayloadSchema,
  ActivityReassignedPayloadSchema,
  EmailActivityChangedPayloadSchema,
  EmailActivityDeletedPayloadSchema,
  EmailLastContactChangedPayloadSchema,
} from './activity-activity-records.events';
import {
  MemberAccessChangedPayloadSchema,
  MemberDeactivatedPayloadSchema,
  MemberInvitedPayloadSchema,
  MemberReactivatedPayloadSchema,
  MemberUpdatedPayloadSchema,
} from './identity-members.events';
import {
  ApiKeyIssuedPayloadSchema,
  ApiKeyRevokedPayloadSchema,
  ApiKeyUpdatedPayloadSchema,
} from './identity-api-keys.events';
import { ConnectedClientAccessUpdatedPayloadSchema } from './identity-connected-clients.events';
import { MemberProfileUpdatedPayloadSchema } from './identity-member-profiles.events';
import {
  AppHandoffMintedPayloadSchema,
  AppHandoffRefusedPayloadSchema,
  AppHandoffSpentPayloadSchema,
} from './identity-app-handoffs.events';
import { MemberOnboardingCompletedPayloadSchema } from './identity-member-onboarding.events';
import { CompanyUpdatedPayloadSchema } from './identity-company.events';
import { DocumentTemplateChangedPayloadSchema } from './identity-document-template.events';
import { EmailTemplateChangedPayloadSchema } from './identity-email-template.events';
import { OrganizationUpdatedPayloadSchema } from './identity-organization.events';
import {
  OrganizationOnboardingInvitedPayloadSchema,
  OrganizationOnboardingInProgressPayloadSchema,
  OrganizationOnboardingSubmittedPayloadSchema,
  OrganizationOnboardingInReviewPayloadSchema,
  OrganizationOnboardingApprovedPayloadSchema,
  OrganizationOnboardingChangesRequestedPayloadSchema,
  OrganizationOnboardingRejectedPayloadSchema,
} from './identity-organization-onboarding.events';
import {
  LeadCreatedPayloadSchema,
  LeadLostPayloadSchema,
  LeadArchivedPayloadSchema,
  LeadReopenedPayloadSchema,
  LeadContactedPayloadSchema,
  LeadConvertedPayloadSchema,
  LeadOwnerUpdatedPayloadSchema,
  LeadNotesUpdatedPayloadSchema,
  LeadLegalBasisUpdatedPayloadSchema,
  LeadIntentUpdatedPayloadSchema,
  LeadPropertyAddressUpdatedPayloadSchema,
  LeadPropertyUpdatedPayloadSchema,
  LeadNoteRecordedPayloadSchema,
  LeadCommunicationRecordedPayloadSchema,
  LeadNoteCompletedPayloadSchema,
  LeadCommunicationCompletedPayloadSchema,
  LeadNoteRescheduledPayloadSchema,
  LeadCommunicationRescheduledPayloadSchema,
  LeadNoteCancelledPayloadSchema,
  LeadCommunicationCancelledPayloadSchema,
  LeadNoteReassignedPayloadSchema,
  LeadCommunicationReassignedPayloadSchema,
  LeadResponsibilityChangedPayloadSchema,
} from './lead-leads.events';
import {
  LeadPartnerCreatedPayloadSchema,
  LeadPartnerDeactivatedPayloadSchema,
  LeadPartnerKeyIssuedPayloadSchema,
  LeadPartnerReactivatedPayloadSchema,
} from './lead-lead-partners.events';
import { PartnerLeadReferenceCreatedPayloadSchema } from './hlre-partner-lead-references.events';
import { AdminAddedPayloadSchema, AdminDeactivatedPayloadSchema } from './admin-admins.events';
import { DocumentAnalysisSkillChangedPayloadSchema } from './admin-document-analysis-skills.events';
import {
  LandIqDataRunFailedChunksRetriedPayloadSchema,
  LandIqDataRunFailedPayloadSchema,
  LandIqDataRunStalePayloadSchema,
  LandIqDataRunStartedPayloadSchema,
  LandIqStageFinishedPayloadSchema,
} from './admin-landiq-data-runs.events';
import { SandboxResetStartedPayloadSchema } from './admin-sandbox-reset.events';
import { SystemSkillChangedPayloadSchema } from './admin-system-skills.events';
import { SkillDefinitionLifecyclePayloadSchema } from './assistant-skill-definitions.events';
import {
  SkillInstanceGrantedPayloadSchema,
  SkillInstanceRevokedPayloadSchema,
} from './assistant-skill-instances.events';
import {
  DocumentRequestCreatedPayloadSchema,
  PropertyActivatedPayloadSchema,
  PropertyArchivedPayloadSchema,
  PropertyAreasUpdatedPayloadSchema,
  PropertyCreatedPayloadSchema,
  PropertyDeactivatedPayloadSchema,
  PropertyDeletedPayloadSchema,
  PropertyHandReservationChangedPayloadSchema,
  PortalListingFirstPublishedPayloadSchema,
  PortalListingBrowserTransmittedPayloadSchema,
  PortalListingBrowserLinkedPayloadSchema,
  PortalListingBrowserRunDecidedPayloadSchema,
  PortalListingBrowserRunFinishedPayloadSchema,
  PortalListingBrowserRunRequestedPayloadSchema,
  PropertyPricingSaleUpdatedPayloadSchema,
  PropertySectionUpdatedPayloadSchema,
  PropertyContactLinkUpdatedPayloadSchema,
  PropertyStatusChangedPayloadSchema,
} from './property-properties.events';
import {
  DocumentRedactionCheckDuePayloadSchema,
  PropertyDocumentAnalysisStateChangedPayloadSchema,
  PropertyDocumentBuyerSharingChangedPayloadSchema,
  PropertyDocumentClassifiedPayloadSchema,
  PropertyDocumentDeletedPayloadSchema,
  PropertyDocumentRefiledPayloadSchema,
} from './property-documents.events';
import { ActivityMemoryReadRequestedPayloadSchema, MemoryEntryChangedPayloadSchema } from './property-memory.events';
import { WebExposePublishedPayloadSchema, WebExposeWithdrawnPayloadSchema } from './property-web-expose.events';
import {
  PropertyCaptureCompletedPayloadSchema,
  PropertyCaptureFindingRecordedPayloadSchema,
  PropertyCapturePhotoAddedPayloadSchema,
  PropertyCaptureStartedPayloadSchema,
} from './property-captures.events';
import {
  DocumentAnalysisCompletedPayloadSchema,
  DocumentAnalysisCorrectedPayloadSchema,
  DossierBriefStalePayloadSchema,
  PropertyAgentFindingsWrittenPayloadSchema,
  PropertyFactKeyCreatedPayloadSchema,
  PropertyFactKeyRetiredPayloadSchema,
  PropertyFactKeyUpdatedPayloadSchema,
  PropertyFactsChangedPayloadSchema,
} from './property-facts.events';
import {
  DealContactAddedPayloadSchema,
  DealContactRemovedPayloadSchema,
  DealContractReceivedPayloadSchema,
  DealCreatedPayloadSchema,
  DealDeferredPayloadSchema,
  DealDeletedPayloadSchema,
  DealRestoredPayloadSchema,
  OrganizationRecordsMovedPayloadSchema,
  DealLostPayloadSchema,
  DealNotesUpdatedPayloadSchema,
  DealPhaseChangedPayloadSchema,
  DealReopenedPayloadSchema,
  DealResponsibilityChangedPayloadSchema,
  DealResumeScheduledPayloadSchema,
  DealResumedPayloadSchema,
  DealWonPayloadSchema,
} from './deal-deals.events';
import {
  BrokerageAgreementConcludedPayloadSchema,
  BrokerageConfirmationRetryDuePayloadSchema,
  BrokerageNoticeReminderDuePayloadSchema,
  BrokerageNoticeSentPayloadSchema,
  BrokerageWithdrawalReceiptRetryDuePayloadSchema,
  BrokerageWithdrawalReceiptSettledPayloadSchema,
  BrokerageEmailDeliveryCheckDuePayloadSchema,
  BrokerageWithdrawalReceivedPayloadSchema,
  BrokerageAcceptanceReplyReceivedPayloadSchema,
  BrokerageAcceptanceReminderDuePayloadSchema,
} from './deal-brokerage-agreements.events';
import {
  DataRoomDocumentAccessedPayloadSchema,
  DataRoomReleaseEndedPayloadSchema,
  DataRoomReleasedPayloadSchema,
} from './deal-data-room.events';
import { InquiryReceivedPayloadSchema } from './deal-inquiries.events';
import {
  BuyerContractTemplateActivatedPayloadSchema,
  BuyerContractTemplateDeletedPayloadSchema,
  BuyerContractTemplateSavedPayloadSchema,
} from './deal-buyer-contract-templates.events';
import {
  ProspectCreatedPayloadSchema,
  ProspectNotaryAppointmentDateChangedPayloadSchema,
  ProspectOfferedPriceChangedPayloadSchema,
  ProspectOfferRecordedPayloadSchema,
  ProspectOfferStatusChangedPayloadSchema,
  ProspectPhaseChangedPayloadSchema,
  ProspectStatusChangedPayloadSchema,
  ProspectViewingAssessedPayloadSchema,
} from './deal-prospects.events';
import {
  GeneratedDocumentCompletedPayloadSchema,
  GeneratedDocumentDeletedPayloadSchema,
  GeneratedDocumentFailedPayloadSchema,
  GeneratedDocumentOriginalReceivedChangedPayloadSchema,
  GeneratedDocumentRequestedPayloadSchema,
} from './deal-generated-documents.events';
import {
  SigningAcceptanceReminderDuePayloadSchema,
  SigningAcceptanceReplyMarkedPayloadSchema,
  SigningEmailDeliveryCheckDuePayloadSchema,
  SigningEmailRetryDuePayloadSchema,
  SigningProofPrunedPayloadSchema,
  SigningRevocationReceivedPayloadSchema,
  SigningRequestCompletedPayloadSchema,
  SigningRequestRemindedPayloadSchema,
  SigningRequestReminderDuePayloadSchema,
  SigningRequestSentPayloadSchema,
  SigningRequestSignedFileReadyPayloadSchema,
  SigningRequestSignerSignedPayloadSchema,
  SigningRequestWithdrawnPayloadSchema,
} from './deal-signing-requests.events';
import {
  ContactAddressUpdatedPayloadSchema,
  ContactCommunicationDeletedPayloadSchema,
  ContactCommunicationRecordedPayloadSchema,
  ContactCommunicationUpdatedPayloadSchema,
  ContactCreatedPayloadSchema,
  ContactDeletedPayloadSchema,
  ContactEmailsUpdatedPayloadSchema,
  ContactNoteDeletedPayloadSchema,
  ContactNoteRecordedPayloadSchema,
  ContactNoteUpdatedPayloadSchema,
  ContactPhonesUpdatedPayloadSchema,
  ContactProfileUpdatedPayloadSchema,
  ContactTypesUpdatedPayloadSchema,
  ContactWarningNoteUpdatedPayloadSchema,
} from './relationship-contacts.events';
import {
  CrmCompanyArchivedPayloadSchema,
  CrmCompanyContactLinkedPayloadSchema,
  CrmCompanyContactLinkUpdatedPayloadSchema,
  CrmCompanyContactUnlinkedPayloadSchema,
  CrmCompanyCreatedPayloadSchema,
  CrmCompanyDeletedPayloadSchema,
  CrmCompanyUnarchivedPayloadSchema,
  CrmCompanyUpdatedPayloadSchema,
} from './relationship-companies.events';
import {
  ValuationRequestCompletedPayloadSchema,
  ValuationRequestDocumentUploadedPayloadSchema,
  ValuationRequestImageUploadedPayloadSchema,
  ValuationRequestReleasedPayloadSchema,
  ValuationRequestReturnedPayloadSchema,
  ValuationRequestSubmittedForApprovalPayloadSchema,
  ValuationRequestSubmittedPayloadSchema,
  ValuationRequestTakenOnPayloadSchema,
  ValuationRequestWithdrawnPayloadSchema,
  ValuationResultAdjustedPayloadSchema,
} from './valuation-requests.events';
import {
  ValuationAgentRequestDeliveredPayloadSchema,
  ValuationAgentRequestFailedPayloadSchema,
  ValuationAgentRequestOpenedPayloadSchema,
  ValuationAgentRequestTakenPayloadSchema,
} from './valuation-agent-requests.events';
import { ValuationAgentResultDeliveredPayloadSchema } from './valuation-agent-results.events';
import { WebhookCreatedPayloadSchema } from './webhook-webhooks.events';
import {
  CalendarChangedPayloadSchema,
  SubscriptionResourceChangedPayloadSchema,
  CalendarEventChangedPayloadSchema,
  AppointmentLinkedPayloadSchema,
  AppointmentUnlinkedPayloadSchema,
  AppointmentWrittenPayloadSchema,
  EmailThreadPlacementChangedPayloadSchema,
  EmailThreadUnassignedPayloadSchema,
  EmailThreadChangedPayloadSchema,
  EmailThreadUpdatedPayloadSchema,
  MailboxChangedPayloadSchema,
  MailboxGrantExpiredPayloadSchema,
  MailboxGrantRevokedPayloadSchema,
  MessageReceivedPayloadSchema,
  MessageSendFailedPayloadSchema,
  MessageSentPayloadSchema,
} from './communication-mailbox-calendar.events';
import { CompanyMailboxLifecyclePayloadSchema } from './communication-company-mailboxes.events';
import {
  WhatsAppDeliveryStateChangedPayloadSchema,
  WhatsAppMemberLinkedPayloadSchema,
  WhatsAppMemberMessageRecordedPayloadSchema,
  WhatsAppMemberUnlinkedPayloadSchema,
  WhatsAppMessageReceivedPayloadSchema,
  WhatsAppStatusReportedPayloadSchema,
} from './communication-whatsapp.events';
import { TelegramMessageReceivedPayloadSchema } from './communication-telegram.events';
import { MessengerSessionRequestedPayloadSchema } from './communication-messenger-sessions.events';
import {
  MessengerDiscussionReceivedPayloadSchema,
  MessengerMessageReceivedPayloadSchema,
} from './communication-messenger-inbound.events';
import { FleetAssistantRepliedPayloadSchema } from './fleet-assistant.events';
import { MessengerOutcomePayloadSchema } from './messenger-outcome';
import { EmailDeliveryCheckDuePayloadSchema } from './communication-email-log.events';
import {
  ViewingInvitationCancelledPayloadSchema,
  ViewingInvitationRemindedPayloadSchema,
  ViewingInvitationRescheduledPayloadSchema,
  ViewingInvitationSentPayloadSchema,
  ViewingReminderDuePayloadSchema,
} from './communication-viewing-invitations.events';
import { ViewingResponseChangedPayloadSchema } from './communication-viewing-responses.events';
import { WhatsAppReplyProducedPayloadSchema } from './assistant-whatsapp.events';
import { FleetCommandIssuedPayloadSchema } from './fleet-commands.events';
import { FleetQuestionAskedPayloadSchema } from './fleet-questions.events';
import type { z } from 'zod';

/**
 * Audit policy declared on every event leaf. `'always'` means the event
 * is persisted to the audit log. Every event recording a write a person,
 * API key, operator or skill made is `'always'` (IMM-1095); `{ never }`
 * exempts an event and must say why — a derived signal, a provider
 * passthrough, a scheduler tick. The reason is required at the type
 * level and checked non-empty by the audit registry test, so an
 * exemption is never silent. Required on every leaf via `EventTree`, so a
 * new event without a decision fails `tsc`.
 */
export type AuditPolicy = 'always' | { readonly never: string };

export type EventLeaf<S extends z.ZodTypeAny = z.ZodTypeAny> = {
  readonly type: string;
  readonly schema: S;
  readonly audited: AuditPolicy;
};

type EventTree = { readonly [key: string]: EventLeaf | EventTree };

/**
 * Cross-cutting event registry. Same tree shape as the HTTP `contracts`
 * (see `contracts.ts`) so future tooling — audit subscriber wiring, i18n
 * description lookup, type-checked publish helpers — can walk both
 * registries uniformly. Each leaf carries `{ type, schema, audited }`:
 * `type` is the wire string used on the bus + audit row, `schema` is the
 * payload Zod schema authored alongside the publishing module, and
 * `audited` is the per-event audit policy enforced by `EventTree`.
 *
 * Adding a new event: define the payload schema in the owning module's
 * `<module>-<topic>.events.ts`, then register it under the matching
 * branch of this tree with an `audited` decision.
 */
export const events = {
  identity: {
    auth: {
      signInSucceeded: {
        type: 'identity.sign-in-succeeded',
        schema: SignInSucceededPayloadSchema,
        audited: 'always',
      },
      signInFailed: {
        type: 'identity.sign-in-failed',
        schema: SignInFailedPayloadSchema,
        audited: 'always',
      },
      signOut: {
        type: 'identity.signed-out',
        schema: SignOutPayloadSchema,
        audited: 'always',
      },
    },
    admin: {
      signInSucceeded: {
        type: 'identity.admin-sign-in-succeeded',
        schema: AdminSignInSucceededPayloadSchema,
        audited: 'always',
      },
      signInFailed: {
        type: 'identity.admin-sign-in-failed',
        schema: AdminSignInFailedPayloadSchema,
        audited: 'always',
      },
      signOut: {
        type: 'identity.admin-signed-out',
        schema: AdminSignOutPayloadSchema,
        audited: 'always',
      },
    },
    access: {
      granted: {
        type: 'identity.access-granted',
        schema: AccessGrantedPayloadSchema,
        audited: 'always',
      },
      denied: {
        type: 'identity.access-denied',
        schema: AccessDeniedPayloadSchema,
        audited: 'always',
      },
      unauthenticated: {
        type: 'identity.access-unauthenticated',
        schema: AccessUnauthenticatedPayloadSchema,
        audited: 'always',
      },
    },
    valuationAgentToken: {
      issued: {
        type: 'identity.valuation-agent-token.issued',
        schema: ValuationAgentTokenIssuedPayloadSchema,
        audited: 'always',
      },
      replaced: {
        type: 'identity.valuation-agent-token.replaced',
        schema: ValuationAgentTokenReplacedPayloadSchema,
        audited: 'always',
      },
      revoked: {
        type: 'identity.valuation-agent-token.revoked',
        schema: ValuationAgentTokenRevokedPayloadSchema,
        audited: 'always',
      },
    },
    mcpAccessSwitch: {
      changed: {
        type: 'identity.mcp-access-switch-changed',
        schema: McpAccessSwitchChangedPayloadSchema,
        audited: 'always',
      },
    },
    // The CUSTOMER MCP surface switch (IMM-601.6) — a SEPARATE leaf from
    // `mcpAccessSwitch` above, which is the operator's own backoffice surface.
    // Two switches, two audit trails: an incident on the customer surface must
    // never read as one on the operator surface.
    workspaceMcpSwitch: {
      changed: {
        type: 'identity.workspace-mcp-switch.changed',
        schema: WorkspaceMcpSwitchChangedPayloadSchema,
        audited: 'always',
      },
    },
    // An operator's admin-MCP call acting for a named member (IMM-1059): the operator is the actor, the member the aggregate.
    actingMemberTool: {
      called: {
        type: 'identity.acting-member-tool.called',
        schema: ActingMemberToolCalledPayloadSchema,
        audited: 'always',
      },
    },
    // Per-tool exposure on the customer MCP surface (IMM-625.2) — a third leaf,
    // for the same reason the second exists: withdrawing one tool is not
    // containing the surface, and the audit trail must not conflate them.
    mcpToolExposure: {
      changed: {
        type: 'identity.mcp-tool-exposure.changed',
        schema: McpToolExposureChangedPayloadSchema,
        audited: 'always',
      },
      staleEntryRemoved: {
        type: 'identity.mcp-tool-exposure.stale-entry-removed',
        schema: McpToolExposureStaleEntryRemovedPayloadSchema,
        audited: 'always',
      },
    },
    workspace: {
      created: {
        type: 'identity.workspace-created',
        schema: WorkspaceCreatedPayloadSchema,
        audited: 'always',
      },
      webAddressChanged: {
        type: 'identity.workspace-web-address-changed',
        schema: WorkspaceWebAddressChangedPayloadSchema,
        audited: 'always',
      },
      linkedToHlre: {
        type: 'identity.workspace-linked-to-hlre',
        schema: WorkspaceLinkedToHlrePayloadSchema,
        audited: 'always',
      },
    },
    // Crossing into a linked application. All three are `audited: 'always'`
    // together (IMM-751.2.2): a trail that recorded only the mint would read as
    // "nobody ever exchanged" rather than "the other half is not built yet", and
    // the refusal is the one an operator most needs — it is the only place the
    // reason a crossing failed is legible, since the wire deliberately answers
    // every cause identically. `handoffId` joins the three; none of them carries
    // the raw token or its digest.
    appHandoff: {
      minted: {
        type: 'identity.app-handoff-minted',
        schema: AppHandoffMintedPayloadSchema,
        audited: 'always',
      },
      spent: {
        type: 'identity.app-handoff-spent',
        schema: AppHandoffSpentPayloadSchema,
        audited: 'always',
      },
      refused: {
        type: 'identity.app-handoff-refused',
        schema: AppHandoffRefusedPayloadSchema,
        audited: 'always',
      },
    },
    member: {
      invited: {
        type: 'identity.member-invited',
        schema: MemberInvitedPayloadSchema,
        audited: 'always',
      },
      updated: {
        type: 'identity.member-updated',
        schema: MemberUpdatedPayloadSchema,
        audited: 'always',
      },
      deactivated: {
        type: 'identity.member-deactivated',
        schema: MemberDeactivatedPayloadSchema,
        audited: 'always',
      },
      reactivated: {
        type: 'identity.member-reactivated',
        schema: MemberReactivatedPayloadSchema,
        audited: 'always',
      },
      // A member's effective authority changed (IMM-516.3): workspace role,
      // organisation roles, or Standort affiliation. Separate from `updated`,
      // which means the profile record changed — a surname correction must not
      // read as an authority change on the audit log or evict the member's
      // open streams.
      accessChanged: {
        type: 'identity.member-access-changed',
        schema: MemberAccessChangedPayloadSchema,
        audited: 'always',
      },
    },
    memberProfile: {
      updated: {
        type: 'identity.member-profile-updated',
        schema: MemberProfileUpdatedPayloadSchema,
        audited: 'always',
      },
    },
    memberOnboarding: {
      completed: {
        type: 'identity.member-onboarding-completed',
        schema: MemberOnboardingCompletedPayloadSchema,
        audited: 'always',
      },
    },
    company: {
      updated: {
        type: 'identity.company-updated',
        schema: CompanyUpdatedPayloadSchema,
        audited: 'always',
      },
    },
    documentTemplate: {
      created: {
        type: 'identity.document-template-created',
        schema: DocumentTemplateChangedPayloadSchema,
        audited: 'always',
      },
      updated: {
        type: 'identity.document-template-updated',
        schema: DocumentTemplateChangedPayloadSchema,
        audited: 'always',
      },
      deleted: {
        type: 'identity.document-template-deleted',
        schema: DocumentTemplateChangedPayloadSchema,
        audited: 'always',
      },
    },
    emailTemplate: {
      created: {
        type: 'identity.email-template-created',
        schema: EmailTemplateChangedPayloadSchema,
        audited: 'always',
      },
      updated: {
        type: 'identity.email-template-updated',
        schema: EmailTemplateChangedPayloadSchema,
        audited: 'always',
      },
      deleted: {
        type: 'identity.email-template-deleted',
        schema: EmailTemplateChangedPayloadSchema,
        audited: 'always',
      },
    },
    organization: {
      updated: {
        type: 'identity.organization-updated',
        schema: OrganizationUpdatedPayloadSchema,
        audited: 'always',
      },
    },
    organizationOnboarding: {
      invited: {
        type: 'identity.organization-onboarding-invited',
        schema: OrganizationOnboardingInvitedPayloadSchema,
        audited: 'always',
      },
      inProgress: {
        type: 'identity.organization-onboarding-in-progress',
        schema: OrganizationOnboardingInProgressPayloadSchema,
        audited: 'always',
      },
      submitted: {
        type: 'identity.organization-onboarding-submitted',
        schema: OrganizationOnboardingSubmittedPayloadSchema,
        audited: 'always',
      },
      inReview: {
        type: 'identity.organization-onboarding-in-review',
        schema: OrganizationOnboardingInReviewPayloadSchema,
        audited: 'always',
      },
      approved: {
        type: 'identity.organization-onboarding-approved',
        schema: OrganizationOnboardingApprovedPayloadSchema,
        audited: 'always',
      },
      changesRequested: {
        type: 'identity.organization-onboarding-changes-requested',
        schema: OrganizationOnboardingChangesRequestedPayloadSchema,
        audited: 'always',
      },
      rejected: {
        type: 'identity.organization-onboarding-rejected',
        schema: OrganizationOnboardingRejectedPayloadSchema,
        audited: 'always',
      },
    },
    apiKey: {
      issued: {
        type: 'identity.api-key-issued',
        schema: ApiKeyIssuedPayloadSchema,
        audited: 'always',
      },
      revoked: {
        type: 'identity.api-key-revoked',
        schema: ApiKeyRevokedPayloadSchema,
        audited: 'always',
      },
      updated: {
        type: 'identity.api-key-updated',
        schema: ApiKeyUpdatedPayloadSchema,
        audited: 'always',
      },
    },
    connectedClient: {
      accessUpdated: {
        type: 'identity.connected-client-access-updated',
        schema: ConnectedClientAccessUpdatedPayloadSchema,
        audited: 'always',
      },
    },
  },
  admin: {
    adminAdded: {
      type: 'admin.admin-added',
      schema: AdminAddedPayloadSchema,
      audited: 'always',
    },
    adminDeactivated: {
      type: 'admin.admin-deactivated',
      schema: AdminDeactivatedPayloadSchema,
      audited: 'always',
    },
    documentAnalysisSkillChanged: {
      type: 'admin.document-analysis-skill-changed',
      schema: DocumentAnalysisSkillChangedPayloadSchema,
      audited: 'always',
    },
    systemSkillChanged: {
      type: 'admin.system-skill-changed',
      schema: SystemSkillChangedPayloadSchema,
      audited: 'always',
    },
    landiqDataRunStarted: {
      type: 'admin.landiq-data-run-started',
      schema: LandIqDataRunStartedPayloadSchema,
      audited: 'always',
    },
    landiqDataRunFailedChunksRetried: {
      type: 'admin.landiq-data-run-failed-chunks-retried',
      schema: LandIqDataRunFailedChunksRetriedPayloadSchema,
      audited: 'always',
    },
    sandboxResetStarted: {
      type: 'admin.sandbox-reset-started',
      schema: SandboxResetStartedPayloadSchema,
      audited: 'always',
    },
    landiqStageFinished: {
      type: 'admin.landiq-stage-finished',
      schema: LandIqStageFinishedPayloadSchema,
      audited: { never: "derived from LandIQ's board on a timer; no operator acted, and the push is its only effect" },
    },
    landiqDataRunFailed: {
      type: 'admin.landiq-data-run-failed',
      schema: LandIqDataRunFailedPayloadSchema,
      audited: { never: "derived from LandIQ's board on a timer; no operator acted, and the push is its only effect" },
    },
    landiqDataRunStale: {
      type: 'admin.landiq-data-run-stale',
      schema: LandIqDataRunStalePayloadSchema,
      audited: { never: "derived from LandIQ's board on a timer; no operator acted, and the push is its only effect" },
    },
  },
  assistant: {
    // Operator lifecycle signals for an agent-skill definition (IMM-436.1),
    // namespaced to the domain that CONSUMES them: IMM-436.2's subscriber lives
    // in the assistant module and pauses/resumes the definition's instances.
    // Audited (IMM-1095): the payload carries the operator `actor`, optional
    // only so a row already in the outbox across the deploy still parses.
    skillDefinition: {
      activated: {
        type: 'assistant.skill-definition.activated',
        schema: SkillDefinitionLifecyclePayloadSchema,
        audited: 'always',
      },
      deactivated: {
        type: 'assistant.skill-definition.deactivated',
        schema: SkillDefinitionLifecyclePayloadSchema,
        audited: 'always',
      },
    },
    // A member granting or revoking a skill's access to act as them is exactly
    // the kind of authority change the audit log exists for, so unlike the
    // definition-lifecycle leaves above these are audited.
    skillInstance: {
      granted: {
        type: 'assistant.skill-instance.granted',
        schema: SkillInstanceGrantedPayloadSchema,
        audited: 'always',
      },
      revoked: {
        type: 'assistant.skill-instance.revoked',
        schema: SkillInstanceRevokedPayloadSchema,
        audited: 'always',
      },
    },
    // The assistant's reply to a WhatsApp turn (IMM-1040.2). `audited: 'never'`
    // — it carries the member's message-turn text, and the run's own step log
    // plus the chat transcript are the record, not the audit log.
    whatsapp: {
      replyProduced: {
        type: 'assistant.whatsapp-reply-produced',
        schema: WhatsAppReplyProducedPayloadSchema,
        audited: {
          never: 'internal hand-off carrying message text; the assistant run log and chat transcript are the record',
        },
      },
    },
  },
  property: {
    property: {
      created: {
        type: 'property.property-created',
        schema: PropertyCreatedPayloadSchema,
        audited: 'always',
      },
      pricingSaleUpdated: {
        type: 'property.pricing-sale-updated',
        schema: PropertyPricingSaleUpdatedPayloadSchema,
        audited: 'always',
      },
      areasUpdated: {
        type: 'property.areas-updated',
        schema: PropertyAreasUpdatedPayloadSchema,
        audited: 'always',
      },
      sectionUpdated: {
        type: 'property.section-updated',
        schema: PropertySectionUpdatedPayloadSchema,
        audited: 'always',
      },
      contactLinkUpdated: {
        type: 'property.contact-link-updated',
        schema: PropertyContactLinkUpdatedPayloadSchema,
        audited: 'always',
      },
      activated: {
        type: 'property.property-activated',
        schema: PropertyActivatedPayloadSchema,
        audited: 'always',
      },
      archived: {
        type: 'property.property-archived',
        schema: PropertyArchivedPayloadSchema,
        audited: 'always',
      },
      deactivated: {
        type: 'property.property-deactivated',
        schema: PropertyDeactivatedPayloadSchema,
        audited: 'always',
      },
      statusChanged: {
        type: 'property.property-status-changed',
        schema: PropertyStatusChangedPayloadSchema,
        audited: 'always',
      },
      deleted: {
        type: 'property.property-deleted',
        schema: PropertyDeletedPayloadSchema,
        audited: 'always',
      },
      handReservationChanged: {
        type: 'property.property-hand-reservation-changed',
        schema: PropertyHandReservationChangedPayloadSchema,
        audited: 'always',
      },
      // A member deleted a stored document (IMM-1095).
      documentDeleted: {
        type: 'property.document-deleted',
        schema: PropertyDocumentDeletedPayloadSchema,
        audited: 'always',
      },
      documentRedactionCheckDue: {
        type: 'property.document-redaction-check-due',
        schema: DocumentRedactionCheckDuePayloadSchema,
        audited: { never: 'scheduler tick, no state change' },
      },
      // A stored document was renamed or recategorised (IMM-1156.3).
      documentRefiled: {
        type: 'property.document-refiled',
        schema: PropertyDocumentRefiledPayloadSchema,
        audited: 'always',
      },
      // A document's „Für Käufer“ mark was set or cleared (IMM-1176.1).
      documentBuyerSharingChanged: {
        type: 'property.document-buyer-sharing-changed',
        schema: PropertyDocumentBuyerSharingChangedPayloadSchema,
        audited: 'always',
      },
      documentRequestCreated: {
        type: 'property.document-request-created',
        schema: DocumentRequestCreatedPayloadSchema,
        audited: 'always',
      },
      documentAnalysisCompleted: {
        type: 'property.document-analysis-completed',
        schema: DocumentAnalysisCompletedPayloadSchema,
        audited: { never: 'machine extraction completion by the system job; the analysis row is the record' },
      },
      documentAnalysisCorrected: {
        type: 'property.document-analysis-corrected',
        schema: DocumentAnalysisCorrectedPayloadSchema,
        audited: 'always',
      },
      factsChanged: {
        type: 'property.facts-changed',
        schema: PropertyFactsChangedPayloadSchema,
        audited: {
          never: 'derived signal, not a change record — the write that causes it is audited on its own event',
        },
      },
      agentFindingsWritten: {
        type: 'property.agent-findings-written',
        schema: PropertyAgentFindingsWrittenPayloadSchema,
        audited: 'always',
      },
      dossierBriefStale: {
        type: 'property.dossier-brief-stale',
        schema: DossierBriefStalePayloadSchema,
        audited: { never: 'cache-invalidation signal published from a read' },
      },
      activityMemoryReadRequested: {
        type: 'property.activity-memory-read-requested',
        schema: ActivityMemoryReadRequestedPayloadSchema,
        audited: { never: 'internal work request, no state change' },
      },
      factKeyCreated: {
        type: 'property.fact-key-created',
        schema: PropertyFactKeyCreatedPayloadSchema,
        audited: 'always',
      },
      factKeyUpdated: {
        type: 'property.fact-key-updated',
        schema: PropertyFactKeyUpdatedPayloadSchema,
        audited: 'always',
      },
      factKeyRetired: {
        type: 'property.fact-key-retired',
        schema: PropertyFactKeyRetiredPayloadSchema,
        audited: 'always',
      },
    },
    document: {
      // Machine classification of one row, at bulk-upload volume. IMM-451's own
      // append-only `property_document_classification_events` table already is
      // the diagnostic record, so the audit log would only duplicate it.
      classified: {
        type: 'property.document-classified',
        schema: PropertyDocumentClassifiedPayloadSchema,
        audited: { never: 'machine classification; property_document_classification_events is the record' },
      },
      // Machine work at bulk volume, one event per lifecycle transition. The
      // analysis row itself is the record, so an audit entry would only
      // duplicate it at several times the rate.
      analysisStateChanged: {
        type: 'property.document-analysis-state-changed',
        schema: PropertyDocumentAnalysisStateChangedPayloadSchema,
        audited: { never: 'progress broadcast for the realtime stream; the analysis row is the record' },
      },
    },
    memory: {
      entryChanged: {
        type: 'property.memory-entry-changed',
        schema: MemoryEntryChangedPayloadSchema,
        audited: 'always',
      },
    },
    portalListing: {
      // The Deal's own phase moves, which this event causes, are audited by the deal module.
      firstPublished: {
        type: 'property.portal-listing-first-published',
        schema: PortalListingFirstPublishedPayloadSchema,
        audited: 'always',
      },
      browserTransmitted: {
        type: 'property.portal-listing-browser-transmitted',
        schema: PortalListingBrowserTransmittedPayloadSchema,
        audited: 'always',
      },
      browserLinked: {
        type: 'property.portal-listing-browser-linked',
        schema: PortalListingBrowserLinkedPayloadSchema,
        audited: 'always',
      },
      browserRunRequested: {
        type: 'property.portal-listing-browser-run-requested',
        schema: PortalListingBrowserRunRequestedPayloadSchema,
        audited: 'always',
      },
      browserRunFinished: {
        type: 'property.portal-listing-browser-run-finished',
        schema: PortalListingBrowserRunFinishedPayloadSchema,
        audited: 'always',
      },
      browserRunDecided: {
        type: 'property.portal-listing-browser-run-decided',
        schema: PortalListingBrowserRunDecidedPayloadSchema,
        audited: 'always',
      },
    },
    capture: {
      started: {
        type: 'property.capture-started',
        schema: PropertyCaptureStartedPayloadSchema,
        audited: 'always',
      },
      findingRecorded: {
        type: 'property.capture-finding-recorded',
        schema: PropertyCaptureFindingRecordedPayloadSchema,
        audited: 'always',
      },
      photoAdded: {
        type: 'property.capture-photo-added',
        schema: PropertyCapturePhotoAddedPayloadSchema,
        audited: 'always',
      },
      completed: {
        type: 'property.capture-completed',
        schema: PropertyCaptureCompletedPayloadSchema,
        audited: 'always',
      },
    },
    webExpose: {
      published: {
        type: 'property.web-expose-published',
        schema: WebExposePublishedPayloadSchema,
        audited: 'always',
      },
      withdrawn: {
        type: 'property.web-expose-withdrawn',
        schema: WebExposeWithdrawnPayloadSchema,
        audited: 'always',
      },
    },
  },
  deal: {
    deal: {
      created: {
        type: 'deal.deal-created',
        schema: DealCreatedPayloadSchema,
        audited: 'always',
      },
      phaseChanged: {
        type: 'deal.deal-phase-changed',
        schema: DealPhaseChangedPayloadSchema,
        audited: 'always',
      },
      contractReceived: {
        type: 'deal.deal-contract-received',
        schema: DealContractReceivedPayloadSchema,
        audited: 'always',
      },
      won: {
        type: 'deal.deal-won',
        schema: DealWonPayloadSchema,
        audited: 'always',
      },
      contactAdded: {
        type: 'deal.deal-contact-added',
        schema: DealContactAddedPayloadSchema,
        audited: 'always',
      },
      contactRemoved: {
        type: 'deal.deal-contact-removed',
        schema: DealContactRemovedPayloadSchema,
        audited: 'always',
      },
      notesUpdated: {
        type: 'deal.deal-notes-updated',
        schema: DealNotesUpdatedPayloadSchema,
        audited: 'always',
      },
      deferred: {
        type: 'deal.deal-deferred',
        schema: DealDeferredPayloadSchema,
        audited: 'always',
      },
      resumed: {
        type: 'deal.deal-resumed',
        schema: DealResumedPayloadSchema,
        audited: 'always',
      },
      resumeScheduled: {
        type: 'deal.deal-resume-scheduled',
        schema: DealResumeScheduledPayloadSchema,
        audited: 'always',
      },
      lost: {
        type: 'deal.deal-lost',
        schema: DealLostPayloadSchema,
        audited: 'always',
      },
      reopened: {
        type: 'deal.deal-reopened',
        schema: DealReopenedPayloadSchema,
        audited: 'always',
      },
      deleted: {
        type: 'deal.deal-deleted',
        schema: DealDeletedPayloadSchema,
        audited: 'always',
      },
      restored: {
        type: 'deal.deal-restored',
        schema: DealRestoredPayloadSchema,
        audited: 'always',
      },
      responsibilityChanged: {
        type: 'deal.responsibility-changed',
        schema: DealResponsibilityChangedPayloadSchema,
        audited: 'always',
      },
    },
    brokerageAgreement: {
      noticeSent: {
        type: 'deal.brokerage-notice-sent',
        schema: BrokerageNoticeSentPayloadSchema,
        audited: 'always',
      },
      reminderDue: {
        type: 'deal.brokerage-notice-reminder-due',
        schema: BrokerageNoticeReminderDuePayloadSchema,
        audited: { never: 'scheduler tick, no state change' },
      },
      concluded: {
        type: 'deal.brokerage-agreement-concluded',
        schema: BrokerageAgreementConcludedPayloadSchema,
        audited: 'always',
      },
      confirmationRetryDue: {
        type: 'deal.brokerage-confirmation-retry-due',
        schema: BrokerageConfirmationRetryDuePayloadSchema,
        audited: { never: 'scheduler retry tick, no state change' },
      },
      withdrawalReceived: {
        type: 'deal.brokerage-withdrawal-received',
        schema: BrokerageWithdrawalReceivedPayloadSchema,
        audited: 'always',
      },
      acceptanceReplyReceived: {
        type: 'deal.brokerage-acceptance-reply-received',
        schema: BrokerageAcceptanceReplyReceivedPayloadSchema,
        audited: 'always',
      },
      acceptanceReminderDue: {
        type: 'deal.brokerage-acceptance-reminder-due',
        schema: BrokerageAcceptanceReminderDuePayloadSchema,
        audited: { never: 'delayed scheduler tick, no state change' },
      },
      withdrawalReceiptRetryDue: {
        type: 'deal.brokerage-withdrawal-receipt-retry-due',
        schema: BrokerageWithdrawalReceiptRetryDuePayloadSchema,
        audited: { never: 'scheduler retry tick, no state change' },
      },
      withdrawalReceiptSettled: {
        type: 'deal.brokerage-withdrawal-receipt-settled',
        schema: BrokerageWithdrawalReceiptSettledPayloadSchema,
        audited: {
          never: "the system job's delivery outcome for the receipt e-mail; the brokerage proof is the record",
        },
      },
      deliveryCheckDue: {
        type: 'deal.brokerage-email-delivery-check-due',
        schema: BrokerageEmailDeliveryCheckDuePayloadSchema,
        audited: { never: 'scheduler tick, no state change' },
      },
    },
    buyerContractTemplate: {
      saved: {
        type: 'deal.buyer-contract-template-saved',
        schema: BuyerContractTemplateSavedPayloadSchema,
        audited: 'always',
      },
      activated: {
        type: 'deal.buyer-contract-template-activated',
        schema: BuyerContractTemplateActivatedPayloadSchema,
        audited: 'always',
      },
      deleted: {
        type: 'deal.buyer-contract-template-deleted',
        schema: BuyerContractTemplateDeletedPayloadSchema,
        audited: 'always',
      },
    },
    dataRoom: {
      released: {
        type: 'deal.data-room.released',
        schema: DataRoomReleasedPayloadSchema,
        audited: 'always',
      },
      releaseEnded: {
        type: 'deal.data-room.release-ended',
        schema: DataRoomReleaseEndedPayloadSchema,
        audited: 'always',
      },
      documentAccessed: {
        type: 'deal.data-room.document-accessed',
        schema: DataRoomDocumentAccessedPayloadSchema,
        audited: {
          never:
            "a buyer's click recorded in the append-only access row itself; no member acted (IMM-1176 Detailed Business Rule 8)",
        },
      },
    },
    organizationRecords: {
      moved: {
        type: 'deal.organization-records-moved',
        schema: OrganizationRecordsMovedPayloadSchema,
        audited: 'always',
      },
    },
    inquiry: {
      received: {
        type: 'deal.inquiry-received',
        schema: InquiryReceivedPayloadSchema,
        audited: 'always',
      },
    },
    prospect: {
      created: {
        type: 'deal.prospect-created',
        schema: ProspectCreatedPayloadSchema,
        audited: 'always',
      },
      phaseChanged: {
        type: 'deal.prospect-phase-changed',
        schema: ProspectPhaseChangedPayloadSchema,
        audited: 'always',
      },
      statusChanged: {
        type: 'deal.prospect-status-changed',
        schema: ProspectStatusChangedPayloadSchema,
        audited: 'always',
      },
      offeredPriceChanged: {
        type: 'deal.prospect-offered-price-changed',
        schema: ProspectOfferedPriceChangedPayloadSchema,
        audited: 'always',
      },
      offerRecorded: {
        type: 'deal.prospect-offer-recorded',
        schema: ProspectOfferRecordedPayloadSchema,
        audited: 'always',
      },
      offerStatusChanged: {
        type: 'deal.prospect-offer-status-changed',
        schema: ProspectOfferStatusChangedPayloadSchema,
        audited: 'always',
      },
      notaryAppointmentDateChanged: {
        type: 'deal.prospect-notary-appointment-date-changed',
        schema: ProspectNotaryAppointmentDateChangedPayloadSchema,
        audited: 'always',
      },
      viewingAssessed: {
        type: 'deal.prospect-viewing-assessed',
        schema: ProspectViewingAssessedPayloadSchema,
        audited: 'always',
      },
    },
    generatedDocument: {
      requested: {
        type: 'deal.generated-document-requested',
        schema: GeneratedDocumentRequestedPayloadSchema,
        audited: 'always',
      },
      completed: {
        type: 'deal.generated-document-completed',
        schema: GeneratedDocumentCompletedPayloadSchema,
        audited: 'always',
      },
      failed: {
        type: 'deal.generated-document-failed',
        schema: GeneratedDocumentFailedPayloadSchema,
        audited: 'always',
      },
      deleted: {
        type: 'deal.generated-document-deleted',
        schema: GeneratedDocumentDeletedPayloadSchema,
        audited: 'always',
      },
      originalReceivedChanged: {
        type: 'deal.generated-document-original-received-changed',
        schema: GeneratedDocumentOriginalReceivedChangedPayloadSchema,
        audited: 'always',
      },
    },
    signingRequest: {
      sent: {
        type: 'deal.signing-request-sent',
        schema: SigningRequestSentPayloadSchema,
        audited: 'always',
      },
      signerSigned: {
        type: 'deal.signing-request-signer-signed',
        schema: SigningRequestSignerSignedPayloadSchema,
        audited: 'always',
      },
      completed: {
        type: 'deal.signing-request-completed',
        schema: SigningRequestCompletedPayloadSchema,
        audited: 'always',
      },
      signedFileReady: {
        type: 'deal.signing-request-signed-file-ready',
        schema: SigningRequestSignedFileReadyPayloadSchema,
        audited: 'always',
      },
      reminderDue: {
        type: 'deal.signing-request-reminder-due',
        schema: SigningRequestReminderDuePayloadSchema,
        audited: { never: 'delayed scheduler tick; the reminder e-mail rows are the record' },
      },
      reminded: {
        type: 'deal.signing-request-reminded',
        schema: SigningRequestRemindedPayloadSchema,
        audited: 'always',
      },
      withdrawn: {
        type: 'deal.signing-request-withdrawn',
        schema: SigningRequestWithdrawnPayloadSchema,
        audited: 'always',
      },
      acceptanceReplyMarked: {
        type: 'deal.signing-acceptance-reply-marked',
        schema: SigningAcceptanceReplyMarkedPayloadSchema,
        audited: 'always',
      },
      revocationReceived: {
        type: 'deal.signing-revocation-received',
        schema: SigningRevocationReceivedPayloadSchema,
        audited: 'always',
      },
      acceptanceReminderDue: {
        type: 'deal.signing-acceptance-reminder-due',
        schema: SigningAcceptanceReminderDuePayloadSchema,
        audited: { never: 'delayed scheduler tick; the reminder e-mail rows are the record' },
      },
      deliveryCheckDue: {
        type: 'deal.signing-request-delivery-check-due',
        schema: SigningEmailDeliveryCheckDuePayloadSchema,
        audited: { never: 'scheduler tick, no state change' },
      },
      emailRetryDue: {
        type: 'deal.signing-request-email-retry-due',
        schema: SigningEmailRetryDuePayloadSchema,
        audited: { never: 'scheduler retry tick; the e-mail rows are the record' },
      },
      proofPruned: {
        type: 'deal.signing-proof-pruned',
        schema: SigningProofPrunedPayloadSchema,
        audited: 'always',
      },
    },
  },
  valuation: {
    request: {
      // The six lifecycle events the activity projection turns into the Deal's
      // valuation timeline (IMM-475.5), alongside `released` below — which the
      // projection subscribes to as its seventh source rather than redefining.
      // Every one is audited (IMM-1095): each records a transition a member or
      // operator made.
      submitted: {
        type: 'valuation.request-submitted',
        schema: ValuationRequestSubmittedPayloadSchema,
        audited: 'always',
      },
      withdrawn: {
        type: 'valuation.request-withdrawn',
        schema: ValuationRequestWithdrawnPayloadSchema,
        audited: 'always',
      },
      takenOn: {
        type: 'valuation.request-taken-on',
        schema: ValuationRequestTakenOnPayloadSchema,
        audited: 'always',
      },
      submittedForApproval: {
        type: 'valuation.request-submitted-for-approval',
        schema: ValuationRequestSubmittedForApprovalPayloadSchema,
        audited: 'always',
      },
      returned: {
        type: 'valuation.request-returned',
        schema: ValuationRequestReturnedPayloadSchema,
        audited: 'always',
      },
      // Emitted when a reviewer RELEASES a valuation request (IMM-475.2). The
      // valuation module only publishes it; communications subscribes to deliver
      // the result to the agent. Audited (IMM-1095); the actor is `releasedBy`.
      released: {
        type: 'valuation.request-released',
        schema: ValuationRequestReleasedPayloadSchema,
        audited: 'always',
      },
      // The pre-IMM-475.2 completion event. NOTHING PUBLISHES IT ANY MORE — it is
      // declared only so the transitional `communications` subscription can keep
      // parsing outbox rows written before the approval gate deployed, and so the
      // e-mail those rows owe still goes out. Delete it, and that subscription,
      // once the outbox has drained.
      completed: {
        type: 'valuation.request-completed',
        schema: ValuationRequestCompletedPayloadSchema,
        audited: { never: 'no publisher — a dead leaf kept only for its transitional subscriber' },
      },
      // Emitted when an UPLOADED document attachment is confirmed (IMM-447.3).
      // The property module subscribes and files a copy into the Objekt's
      // documents. `audited: 'never'` — like `completed` it is an internal
      // reaction trigger carrying no `actor` envelope; the attachment itself is
      // auditable at the request aggregate, not on this event.
      documentUploaded: {
        type: 'valuation.request-document-uploaded',
        schema: ValuationRequestDocumentUploadedPayloadSchema,
        audited: { never: 'no publisher — a dead leaf kept only for its transitional subscriber' },
      },
      // Emitted when an UPLOADED image attachment is confirmed (IMM-447.4). The
      // property module subscribes and files a copy into the Objekt's Bilder
      // gallery. Audited (IMM-1095): a member attached a file. The actor is
      // `actor`, falling back to `uploadedByMemberId` for pre-deploy rows.
      imageUploaded: {
        type: 'valuation.request-image-uploaded',
        schema: ValuationRequestImageUploadedPayloadSchema,
        audited: 'always',
      },
    },
    // The HELD result, not the request lifecycle — its own topic, because an
    // adjustment changes the figures without moving the request's status.
    result: {
      adjusted: {
        type: 'valuation.result-adjusted',
        schema: ValuationResultAdjustedPayloadSchema,
        audited: 'always',
      },
    },
    valuationAgentRequest: {
      opened: {
        type: 'valuation.valuation-agent-request.opened',
        schema: ValuationAgentRequestOpenedPayloadSchema,
        audited: 'always',
      },
      taken: {
        type: 'valuation.valuation-agent-request.taken',
        schema: ValuationAgentRequestTakenPayloadSchema,
        audited: 'always',
      },
      failed: {
        type: 'valuation.valuation-agent-request.failed',
        schema: ValuationAgentRequestFailedPayloadSchema,
        audited: 'always',
      },
      delivered: {
        type: 'valuation.valuation-agent-request.delivered',
        schema: ValuationAgentRequestDeliveredPayloadSchema,
        audited: 'always',
      },
    },
    agentResult: {
      delivered: {
        type: 'valuation.agent-result-delivered',
        schema: ValuationAgentResultDeliveredPayloadSchema,
        audited: 'always',
      },
    },
  },
  relationship: {
    contact: {
      created: {
        type: 'relationship.contact-created',
        schema: ContactCreatedPayloadSchema,
        audited: 'always',
      },
      profileUpdated: {
        type: 'relationship.contact-profile-updated',
        schema: ContactProfileUpdatedPayloadSchema,
        audited: 'always',
      },
      typesUpdated: {
        type: 'relationship.contact-types-updated',
        schema: ContactTypesUpdatedPayloadSchema,
        audited: 'always',
      },
      emailsUpdated: {
        type: 'relationship.contact-emails-updated',
        schema: ContactEmailsUpdatedPayloadSchema,
        audited: 'always',
      },
      phonesUpdated: {
        type: 'relationship.contact-phones-updated',
        schema: ContactPhonesUpdatedPayloadSchema,
        audited: 'always',
      },
      addressUpdated: {
        type: 'relationship.contact-address-updated',
        schema: ContactAddressUpdatedPayloadSchema,
        audited: 'always',
      },
      warningNoteUpdated: {
        type: 'relationship.contact-warning-note-updated',
        schema: ContactWarningNoteUpdatedPayloadSchema,
        audited: 'always',
      },
      noteRecorded: {
        type: 'relationship.contact-note-recorded',
        schema: ContactNoteRecordedPayloadSchema,
        audited: 'always',
      },
      communicationRecorded: {
        type: 'relationship.contact-communication-recorded',
        schema: ContactCommunicationRecordedPayloadSchema,
        audited: 'always',
      },
      noteUpdated: {
        type: 'relationship.contact-note-updated',
        schema: ContactNoteUpdatedPayloadSchema,
        audited: 'always',
      },
      communicationUpdated: {
        type: 'relationship.contact-communication-updated',
        schema: ContactCommunicationUpdatedPayloadSchema,
        audited: 'always',
      },
      noteDeleted: {
        type: 'relationship.contact-note-deleted',
        schema: ContactNoteDeletedPayloadSchema,
        audited: 'always',
      },
      communicationDeleted: {
        type: 'relationship.contact-communication-deleted',
        schema: ContactCommunicationDeletedPayloadSchema,
        audited: 'always',
      },
      deleted: {
        type: 'relationship.contact-deleted',
        schema: ContactDeletedPayloadSchema,
        audited: 'always',
      },
    },
    company: {
      created: {
        type: 'relationship.company-created',
        schema: CrmCompanyCreatedPayloadSchema,
        audited: 'always',
      },
      updated: {
        type: 'relationship.company-updated',
        schema: CrmCompanyUpdatedPayloadSchema,
        audited: 'always',
      },
      archived: {
        type: 'relationship.company-archived',
        schema: CrmCompanyArchivedPayloadSchema,
        audited: 'always',
      },
      unarchived: {
        type: 'relationship.company-unarchived',
        schema: CrmCompanyUnarchivedPayloadSchema,
        audited: 'always',
      },
      deleted: {
        type: 'relationship.company-deleted',
        schema: CrmCompanyDeletedPayloadSchema,
        audited: 'always',
      },
    },
    companyContact: {
      linked: {
        type: 'relationship.company-contact-linked',
        schema: CrmCompanyContactLinkedPayloadSchema,
        audited: 'always',
      },
      unlinked: {
        type: 'relationship.company-contact-unlinked',
        schema: CrmCompanyContactUnlinkedPayloadSchema,
        audited: 'always',
      },
      linkUpdated: {
        type: 'relationship.company-contact-link-updated',
        schema: CrmCompanyContactLinkUpdatedPayloadSchema,
        audited: 'always',
      },
    },
  },
  lead: {
    lead: {
      created: {
        type: 'lead.lead-created',
        schema: LeadCreatedPayloadSchema,
        audited: 'always',
      },
      lost: {
        type: 'lead.lead-lost',
        schema: LeadLostPayloadSchema,
        audited: 'always',
      },
      archived: {
        type: 'lead.lead-archived',
        schema: LeadArchivedPayloadSchema,
        audited: 'always',
      },
      reopened: {
        type: 'lead.lead-reopened',
        schema: LeadReopenedPayloadSchema,
        audited: 'always',
      },
      contacted: {
        type: 'lead.lead-contacted',
        schema: LeadContactedPayloadSchema,
        audited: 'always',
      },
      converted: {
        type: 'lead.lead-converted',
        schema: LeadConvertedPayloadSchema,
        audited: 'always',
      },
      ownerUpdated: {
        type: 'lead.lead-owner-updated',
        schema: LeadOwnerUpdatedPayloadSchema,
        audited: 'always',
      },
      notesUpdated: {
        type: 'lead.lead-notes-updated',
        schema: LeadNotesUpdatedPayloadSchema,
        audited: 'always',
      },
      legalBasisUpdated: {
        type: 'lead.lead-legal-basis-updated',
        schema: LeadLegalBasisUpdatedPayloadSchema,
        audited: 'always',
      },
      intentUpdated: {
        type: 'lead.lead-intent-updated',
        schema: LeadIntentUpdatedPayloadSchema,
        audited: 'always',
      },
      propertyAddressUpdated: {
        type: 'lead.lead-property-address-updated',
        schema: LeadPropertyAddressUpdatedPayloadSchema,
        audited: 'always',
      },
      propertyUpdated: {
        type: 'lead.lead-property-updated',
        schema: LeadPropertyUpdatedPayloadSchema,
        audited: 'always',
      },
      noteRecorded: {
        type: 'lead.lead-note-recorded',
        schema: LeadNoteRecordedPayloadSchema,
        audited: 'always',
      },
      communicationRecorded: {
        type: 'lead.lead-communication-recorded',
        schema: LeadCommunicationRecordedPayloadSchema,
        audited: 'always',
      },
      noteCompleted: {
        type: 'lead.lead-note-completed',
        schema: LeadNoteCompletedPayloadSchema,
        audited: 'always',
      },
      communicationCompleted: {
        type: 'lead.lead-communication-completed',
        schema: LeadCommunicationCompletedPayloadSchema,
        audited: 'always',
      },
      noteRescheduled: {
        type: 'lead.lead-note-rescheduled',
        schema: LeadNoteRescheduledPayloadSchema,
        audited: 'always',
      },
      communicationRescheduled: {
        type: 'lead.lead-communication-rescheduled',
        schema: LeadCommunicationRescheduledPayloadSchema,
        audited: 'always',
      },
      noteCancelled: {
        type: 'lead.lead-note-cancelled',
        schema: LeadNoteCancelledPayloadSchema,
        audited: 'always',
      },
      communicationCancelled: {
        type: 'lead.lead-communication-cancelled',
        schema: LeadCommunicationCancelledPayloadSchema,
        audited: 'always',
      },
      noteReassigned: {
        type: 'lead.lead-note-reassigned',
        schema: LeadNoteReassignedPayloadSchema,
        audited: 'always',
      },
      communicationReassigned: {
        type: 'lead.lead-communication-reassigned',
        schema: LeadCommunicationReassignedPayloadSchema,
        audited: 'always',
      },
      responsibilityChanged: {
        type: 'lead.responsibility-changed',
        schema: LeadResponsibilityChangedPayloadSchema,
        audited: 'always',
      },
    },
    leadPartner: {
      created: {
        type: 'lead.lead-partner-created',
        schema: LeadPartnerCreatedPayloadSchema,
        audited: 'always',
      },
      deactivated: {
        type: 'lead.lead-partner-deactivated',
        schema: LeadPartnerDeactivatedPayloadSchema,
        audited: 'always',
      },
      reactivated: {
        type: 'lead.lead-partner-reactivated',
        schema: LeadPartnerReactivatedPayloadSchema,
        audited: 'always',
      },
      keyIssued: {
        type: 'lead.lead-partner-key-issued',
        schema: LeadPartnerKeyIssuedPayloadSchema,
        audited: 'always',
      },
    },
  },
  activity: {
    activity: {
      // A plannable activity written to the shared store (IMM-430.1 / ADR 0035).
      // The activity module subscribes to its own event to project the record
      // onto the unified timeline, keeping store and projection separate.
      recorded: {
        type: 'activity.activity-recorded',
        schema: ActivityRecordedPayloadSchema,
        audited: 'always',
      },
      // The transitions (IMM-430.3). Each AMENDS the projected timeline entry
      // rather than recording a second one.
      completed: {
        type: 'activity.activity-completed',
        schema: ActivityCompletedPayloadSchema,
        audited: 'always',
      },
      rescheduled: {
        type: 'activity.activity-rescheduled',
        schema: ActivityRescheduledPayloadSchema,
        audited: 'always',
      },
      cancelled: {
        type: 'activity.activity-cancelled',
        schema: ActivityCancelledPayloadSchema,
        audited: 'always',
      },
      updated: {
        type: 'activity.activity-updated',
        schema: ActivityUpdatedPayloadSchema,
        audited: 'always',
      },
      reassigned: {
        type: 'activity.activity-reassigned',
        schema: ActivityReassignedPayloadSchema,
        audited: 'always',
      },
      // A member deleted an e-mail activity (IMM-1095).
      emailDeleted: {
        type: 'activity.email-activity-deleted',
        schema: EmailActivityDeletedPayloadSchema,
        audited: 'always',
      },
      // An e-mail activity was recorded, moved or deleted by the thread reconcile
      // (IMM-866.1). `audited: 'never'` — an internal projection trigger.
      emailChanged: {
        type: 'activity.email-activity-changed',
        schema: EmailActivityChangedPayloadSchema,
        audited: {
          never: 'derived signal, not a change record — the write that causes it is audited on its own event',
        },
      },
      // Some Kontakt's or Lead's counted e-mail set changed (IMM-866.3). A value-less
      // refresh trigger, so `audited: 'never'`.
      emailLastContactChanged: {
        type: 'activity.email-last-contact-changed',
        schema: EmailLastContactChangedPayloadSchema,
        audited: { never: 'cache-refresh trigger carrying no values' },
      },
    },
  },
  webhook: {
    webhook: {
      // Internal ingestion plumbing (IMM-90 / ADR 0016), not a business audit
      // event — the audit trail lives in `webhooks.webhook_status_changes`.
      created: {
        type: 'webhook.webhook-created',
        schema: WebhookCreatedPayloadSchema,
        audited: { never: 'inbound webhook ingestion plumbing; webhooks.webhook_status_changes is the record' },
      },
    },
  },
  communication: {
    // Normalised mailbox + calendar events emitted by the Nylas webhook parser
    // (IMM-88 / ADR 0018). `audited: 'never'` — these are vendor passthroughs, not
    // user-initiated domain mutations; auditing happens at the consuming aggregate.
    message: {
      received: {
        type: 'communication.message-received',
        schema: MessageReceivedPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
      sent: {
        type: 'communication.message-sent',
        schema: MessageSentPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
      sendFailed: {
        type: 'communication.message-send-failed',
        schema: MessageSendFailedPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
    },
    email: {
      deliveryCheckDue: {
        type: 'communication.email-delivery-check-due',
        schema: EmailDeliveryCheckDuePayloadSchema,
        audited: { never: 'delayed scheduler tick' },
      },
    },
    whatsapp: {
      statusReported: {
        type: 'communication.whatsapp-status-reported',
        schema: WhatsAppStatusReportedPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
      // Superseded by `communication.messenger-message-received`; still subscribed so rows written before the
      // switch drain. Remove once a release has shipped without it.
      messageReceived: {
        type: 'communication.whatsapp-message-received',
        schema: WhatsAppMessageReceivedPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
      deliveryStateChanged: {
        type: 'communication.whatsapp-delivery-state-changed',
        schema: WhatsAppDeliveryStateChangedPayloadSchema,
        audited: { never: 'realtime stream push of a provider delivery receipt' },
      },
      // Binding/unbinding a WhatsApp number to a member (IMM-1040.1) — an
      // authentication change, so both are always audited.
      memberLinked: {
        type: 'communication.whatsapp-member-linked',
        schema: WhatsAppMemberLinkedPayloadSchema,
        audited: 'always',
      },
      memberUnlinked: {
        type: 'communication.whatsapp-member-unlinked',
        schema: WhatsAppMemberUnlinkedPayloadSchema,
        audited: 'always',
      },
      // A connected member's inbound WhatsApp text (IMM-1040.2). `audited:
      // 'never'` — it carries message text, and the chat transcript is the record.
      memberMessageRecorded: {
        type: 'communication.whatsapp-member-message-recorded',
        schema: WhatsAppMemberMessageRecordedPayloadSchema,
        audited: { never: 'inbound message text; the chat transcript is the record' },
      },
    },
    telegram: {
      // Superseded by `communication.messenger-message-received`; still subscribed so rows written before the
      // switch drain. Remove once a release has shipped without it.
      messageReceived: {
        type: 'communication.telegram-message-received',
        schema: TelegramMessageReceivedPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
    },
    // Internal delivery trigger of the messenger-session queue (IMM-1097.1).
    messenger: {
      // Every inbound messenger message, normalised by its webhook parser (ADR 0063).
      messageReceived: {
        type: 'communication.messenger-message-received',
        schema: MessengerMessageReceivedPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
      // A fleet person's text on the fleet line, on its way to the fleet assistant (IMM-1420).
      discussionReceived: {
        type: 'communication.messenger-discussion-received',
        schema: MessengerDiscussionReceivedPayloadSchema,
        audited: { never: 'the message row in immo_fleet.fleet_assistant_messages is the record' },
      },
      sessionRequested: {
        type: 'communication.messenger-session-requested',
        schema: MessengerSessionRequestedPayloadSchema,
        audited: {
          never:
            "internal delivery trigger — the caller's write that asked for the session is audited on its own event",
        },
      },
    },
    // A company mailbox was connected, reconnected or disconnected (IMM-264) — audited; connected and reconnected trigger a pull.
    companyMailbox: {
      connected: {
        type: 'communication.company-mailbox-connected',
        schema: CompanyMailboxLifecyclePayloadSchema,
        audited: 'always',
      },
      reconnected: {
        type: 'communication.company-mailbox-reconnected',
        schema: CompanyMailboxLifecyclePayloadSchema,
        audited: 'always',
      },
      disconnected: {
        type: 'communication.company-mailbox-disconnected',
        schema: CompanyMailboxLifecyclePayloadSchema,
        audited: 'always',
      },
    },
    // A viewing invitation mail went out to a Kontakt (IMM-1067.2) — a mail to a third party, so always audited.
    viewingInvitation: {
      sent: {
        type: 'communication.viewing-invitation-sent',
        schema: ViewingInvitationSentPayloadSchema,
        audited: 'always',
      },
      rescheduled: {
        type: 'communication.viewing-invitation-rescheduled',
        schema: ViewingInvitationRescheduledPayloadSchema,
        audited: 'always',
      },
      cancelled: {
        type: 'communication.viewing-invitation-cancelled',
        schema: ViewingInvitationCancelledPayloadSchema,
        audited: 'always',
      },
      reminderDue: {
        type: 'communication.viewing-reminder-due',
        schema: ViewingReminderDuePayloadSchema,
        audited: { never: 'delayed scheduler tick' },
      },
      reminded: {
        type: 'communication.viewing-invitation-reminded',
        schema: ViewingInvitationRemindedPayloadSchema,
        audited: 'always',
      },
    },
    calendarEvent: {
      created: {
        type: 'communication.calendar-event-created',
        schema: CalendarEventChangedPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
      updated: {
        type: 'communication.calendar-event-updated',
        schema: CalendarEventChangedPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
      deleted: {
        type: 'communication.calendar-event-deleted',
        schema: CalendarEventChangedPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
    },
    // The direct-path (IMM-530.5) push notifications. Thinner than their Nylas
    // siblings above by design: Google tells us only THAT something changed, so
    // the diff — which needs the grant's credential and watermark — happens in
    // the `communications` subscriber rather than in the parser.
    mailbox: {
      changed: {
        type: 'communication.mailbox-changed',
        schema: MailboxChangedPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
    },
    calendar: {
      changed: {
        type: 'communication.calendar-changed',
        schema: CalendarChangedPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
    },
    subscriptionResource: {
      changed: {
        type: 'communication.subscription-resource-changed',
        schema: SubscriptionResourceChangedPayloadSchema,
        audited: {
          never:
            'provider passthrough — not initiated in immoOS; the state change it causes is audited where it is applied',
        },
      },
    },
    mailboxGrant: {
      expired: {
        type: 'communication.mailbox-grant-expired',
        schema: MailboxGrantExpiredPayloadSchema,
        audited: 'always',
      },
      revoked: {
        type: 'communication.mailbox-grant-revoked',
        schema: MailboxGrantRevokedPayloadSchema,
        audited: 'always',
      },
    },
    appointment: {
      // A member's own appointment writes in immoOS (IMM-1095) — the audit
      // record the link projections below cannot be.
      created: {
        type: 'communication.appointment-created',
        schema: AppointmentWrittenPayloadSchema,
        audited: 'always',
      },
      updated: {
        type: 'communication.appointment-updated',
        schema: AppointmentWrittenPayloadSchema,
        audited: 'always',
      },
      cancelled: {
        type: 'communication.appointment-cancelled',
        schema: AppointmentWrittenPayloadSchema,
        audited: 'always',
      },
      // Calendar appointment ↔ record link projections (IMM-234.8). `audited:
      // 'never'` — internal read-model projections the activity module consumes,
      // exactly like their `emailThread` siblings.
      linked: {
        type: 'communication.appointment-linked',
        schema: AppointmentLinkedPayloadSchema,
        audited: {
          never: 'idempotent re-projection of current links; the appointment write is audited on its own event',
        },
      },
      unlinked: {
        type: 'communication.appointment-unlinked',
        schema: AppointmentUnlinkedPayloadSchema,
        audited: {
          never: 'idempotent re-projection of current links; the appointment write is audited on its own event',
        },
      },
    },
    viewingResponse: {
      // The buyer's answer on a Besichtigung changed (IMM-1068.2). `audited: 'never'` like `appointment-linked`: a
      // projection of provider state with no acting member; the timeline entry is the record.
      changed: {
        type: 'communication.viewing-response-changed',
        schema: ViewingResponseChangedPayloadSchema,
        audited: {
          never: 'projection of provider state with no acting member; the timeline entry is the record',
        },
      },
    },
    emailThread: {
      // Enriched, contact-matched thread projection (IMM-233.1.1). `audited:
      // 'never'` — it is an internal read-model projection the activity module
      // consumes, not a user-initiated domain mutation; auditing happens at the
      // consuming aggregate (the contact timeline entry).
      updated: {
        type: 'communication.email-thread-updated',
        schema: EmailThreadUpdatedPayloadSchema,
        audited: { never: 'no publisher — a dead leaf kept only for its transitional subscriber' },
      },
      // Thread detached from a contact (IMM-233.4). `audited: 'never'` — like its
      // `updated` sibling it drives an internal read-model projection (the activity
      // module RETRACTS the contact-timeline entry); the user-initiated assignment
      // change is auditable at the consuming aggregate, not on this projection event.
      unassigned: {
        type: 'communication.email-thread-unassigned',
        schema: EmailThreadUnassignedPayloadSchema,
        audited: { never: 'no publisher — a dead leaf kept only for its transitional subscriber' },
      },
      // A member placed a Konversation or removed its placement (IMM-1095).
      placementChanged: {
        type: 'communication.email-thread-placement-changed',
        schema: EmailThreadPlacementChangedPayloadSchema,
        audited: 'always',
      },
      // A personal thread with a placement changed (IMM-866.1). `audited: 'never'` —
      // an internal trigger the activity module reconciles e-mail activities from.
      changed: {
        type: 'communication.email-thread-changed',
        schema: EmailThreadChangedPayloadSchema,
        audited: {
          never: 'derived signal, not a change record — the write that causes it is audited on its own event',
        },
      },
    },
  },
  hlre: {
    partnerLeadReference: {
      created: {
        type: 'hlre.partner-lead-reference-created',
        schema: PartnerLeadReferenceCreatedPayloadSchema,
        audited: 'always',
      },
    },
  },
  fleet: {
    // A command was accepted and needs relaying to its machine (IMM-910.5,
    // ADR 0047 amendment). `audited: 'never'` — `immo_fleet.fleet_commands` is
    // already the queryable copy carrying `requestedByAdminId` /
    // `requestedAt`, and the relay channel is the durable record; this event
    // exists to deliver the command to the outbox subscriber, not to record
    // it a third time.
    command: {
      issued: {
        type: 'fleet.command-issued',
        schema: FleetCommandIssuedPayloadSchema,
        audited: { never: 'no publisher — fleet_commands.requested_by_admin_id is the record' },
      },
    },
    question: {
      asked: {
        type: 'fleet.question-asked',
        schema: FleetQuestionAskedPayloadSchema,
        audited: { never: 'the question row is the record' },
      },
      replied: {
        type: 'fleet.question-replied',
        schema: MessengerOutcomePayloadSchema,
        audited: { never: 'the answer is recorded on the question row' },
      },
    },
    // The reporter answered a parked report's question over WhatsApp (OPS-63).
    report: {
      replied: {
        type: 'fleet.report-replied',
        schema: MessengerOutcomePayloadSchema,
        audited: { never: 'the reply is recorded in the report conversation' },
      },
    },
    // The fleet assistant answered a turn, or a turn failed (IMM-1420).
    assistant: {
      replied: {
        type: 'fleet.assistant-replied',
        schema: FleetAssistantRepliedPayloadSchema,
        audited: { never: 'the assistant message row is the record' },
      },
    },
    // A one-way fleet notice (a park, a silent worker) failed to send (OPS-62).
    // No subscriber: the outcome event is what keys the session's
    // idempotency, and a delivered notice publishes nothing.
    notice: {
      settled: {
        type: 'fleet.notice-settled',
        schema: MessengerOutcomePayloadSchema,
        audited: { never: 'the session row is the record' },
      },
    },
  },
} as const satisfies EventTree;

export type Events = typeof events;

export { SignInFailedPayloadSchema, SignInSucceededPayloadSchema, SignOutPayloadSchema } from './identity-auth.events';
export {
  ActingMemberToolCalledPayloadSchema,
  AdminSignInFailedPayloadSchema,
  AdminSignInSucceededPayloadSchema,
  AdminSignOutPayloadSchema,
} from './identity-admin.events';
export {
  AccessDeniedPayloadSchema,
  AccessGrantedPayloadSchema,
  AccessReadSchema,
  AccessUnauthenticatedPayloadSchema,
  AuditFileTypeSchema,
  AuditRecordTypeSchema,
  McpToolExposureChangedPayloadSchema,
} from './identity-access.events';
export type { AccessRead, AuditFileType, AuditRecordType } from './identity-access.events';
export {
  ValuationAgentTokenIssuedPayloadSchema,
  ValuationAgentTokenReplacedPayloadSchema,
  ValuationAgentTokenRevokedPayloadSchema,
} from './identity-valuation-agent-tokens.events';
export type {
  ValuationAgentTokenIssuedPayload,
  ValuationAgentTokenReplacedPayload,
  ValuationAgentTokenRevokedPayload,
} from './identity-valuation-agent-tokens.events';
export {
  WorkspaceCreatedPayloadSchema,
  WorkspaceLinkedToHlrePayloadSchema,
  WorkspaceWebAddressChangedPayloadSchema,
} from './identity-workspace.events';
export {
  MemberAccessChangedPayloadSchema,
  MemberDeactivatedPayloadSchema,
  MemberInvitedPayloadSchema,
  MemberReactivatedPayloadSchema,
  MemberUpdatedPayloadSchema,
} from './identity-members.events';
export type {
  MemberAccessChangedPayload,
  MemberDeactivatedPayload,
  MemberInvitedPayload,
  MemberReactivatedPayload,
  MemberUpdatedPayload,
} from './identity-members.events';
export { MemberProfileUpdatedPayloadSchema } from './identity-member-profiles.events';
export type { MemberProfileUpdatedPayload } from './identity-member-profiles.events';
export { MemberOnboardingCompletedPayloadSchema } from './identity-member-onboarding.events';
export type { MemberOnboardingCompletedPayload } from './identity-member-onboarding.events';
export { CompanyUpdatedPayloadSchema } from './identity-company.events';
export type { CompanyUpdatedPayload } from './identity-company.events';
export { DocumentTemplateChangedPayloadSchema } from './identity-document-template.events';
export {
  BuyerContractTemplateActivatedPayloadSchema,
  BuyerContractTemplateDeletedPayloadSchema,
  BuyerContractTemplateSavedPayloadSchema,
} from './deal-buyer-contract-templates.events';
export type {
  BuyerContractTemplateActivatedPayload,
  BuyerContractTemplateDeletedPayload,
  BuyerContractTemplateSavedPayload,
} from './deal-buyer-contract-templates.events';
export type { DocumentTemplateChangedPayload } from './identity-document-template.events';
export { EmailTemplateChangedPayloadSchema } from './identity-email-template.events';
export type { EmailTemplateChangedPayload } from './identity-email-template.events';
export { OrganizationUpdatedPayloadSchema } from './identity-organization.events';
export type { OrganizationUpdatedPayload } from './identity-organization.events';
export {
  OrganizationOnboardingInvitedPayloadSchema,
  OrganizationOnboardingInProgressPayloadSchema,
  OrganizationOnboardingSubmittedPayloadSchema,
  OrganizationOnboardingInReviewPayloadSchema,
  OrganizationOnboardingApprovedPayloadSchema,
  OrganizationOnboardingChangesRequestedPayloadSchema,
  OrganizationOnboardingRejectedPayloadSchema,
} from './identity-organization-onboarding.events';
export type {
  OrganizationOnboardingInvitedPayload,
  OrganizationOnboardingInProgressPayload,
  OrganizationOnboardingSubmittedPayload,
  OrganizationOnboardingInReviewPayload,
  OrganizationOnboardingApprovedPayload,
  OrganizationOnboardingChangesRequestedPayload,
  OrganizationOnboardingRejectedPayload,
} from './identity-organization-onboarding.events';
export {
  ApiKeyIssuedPayloadSchema,
  ApiKeyRevokedPayloadSchema,
  ApiKeyUpdatedPayloadSchema,
} from './identity-api-keys.events';
export type { ApiKeyIssuedPayload, ApiKeyRevokedPayload, ApiKeyUpdatedPayload } from './identity-api-keys.events';
export { ConnectedClientAccessUpdatedPayloadSchema } from './identity-connected-clients.events';
export type { ConnectedClientAccessUpdatedPayload } from './identity-connected-clients.events';
export {
  LeadCreatedPayloadSchema,
  LeadLostPayloadSchema,
  LeadArchivedPayloadSchema,
  LeadReopenedPayloadSchema,
  LeadContactedPayloadSchema,
  LeadConvertedPayloadSchema,
  LeadOwnerUpdatedPayloadSchema,
  LeadNotesUpdatedPayloadSchema,
  LeadLegalBasisUpdatedPayloadSchema,
  LeadIntentUpdatedPayloadSchema,
  LeadPropertyAddressUpdatedPayloadSchema,
  LeadPropertyUpdatedPayloadSchema,
  LeadNoteRecordedPayloadSchema,
  LeadCommunicationRecordedPayloadSchema,
  LeadNoteCompletedPayloadSchema,
  LeadCommunicationCompletedPayloadSchema,
  LeadNoteRescheduledPayloadSchema,
  LeadCommunicationRescheduledPayloadSchema,
  LeadNoteCancelledPayloadSchema,
  LeadCommunicationCancelledPayloadSchema,
  LeadNoteReassignedPayloadSchema,
  LeadCommunicationReassignedPayloadSchema,
  LeadResponsibilityChangedPayloadSchema,
} from './lead-leads.events';
export type {
  LeadCreatedPayload,
  LeadLostPayload,
  LeadArchivedPayload,
  LeadReopenedPayload,
  LeadContactedPayload,
  LeadConvertedPayload,
  LeadOwnerUpdatedPayload,
  LeadNotesUpdatedPayload,
  LeadLegalBasisUpdatedPayload,
  LeadIntentUpdatedPayload,
  LeadPropertyAddressUpdatedPayload,
  LeadPropertyUpdatedPayload,
  LeadNoteRecordedPayload,
  LeadCommunicationRecordedPayload,
  LeadNoteCompletedPayload,
  LeadCommunicationCompletedPayload,
  LeadNoteRescheduledPayload,
  LeadCommunicationRescheduledPayload,
  LeadNoteCancelledPayload,
  LeadCommunicationCancelledPayload,
  LeadNoteReassignedPayload,
  LeadCommunicationReassignedPayload,
  LeadResponsibilityChangedPayload,
  LeadAssignmentTrigger,
} from './lead-leads.events';
export {
  LeadPartnerCreatedPayloadSchema,
  LeadPartnerDeactivatedPayloadSchema,
  LeadPartnerKeyIssuedPayloadSchema,
  LeadPartnerReactivatedPayloadSchema,
} from './lead-lead-partners.events';
export type {
  LeadPartnerCreatedPayload,
  LeadPartnerDeactivatedPayload,
  LeadPartnerKeyIssuedPayload,
  LeadPartnerReactivatedPayload,
} from './lead-lead-partners.events';
export {
  PartnerLeadReferenceCreatedPayloadSchema,
  type PartnerLeadReferenceCreatedPayload,
} from './hlre-partner-lead-references.events';
export { AdminAddedPayloadSchema, AdminDeactivatedPayloadSchema } from './admin-admins.events';
export {
  DocumentAnalysisSkillChangedPayloadSchema,
  type DocumentAnalysisSkillChangedPayload,
  SkillChangeViaSchema,
  type SkillChangeVia,
} from './admin-document-analysis-skills.events';
export { SystemSkillChangedPayloadSchema, type SystemSkillChangedPayload } from './admin-system-skills.events';
export {
  LandIqDataRunFailedChunksRetriedPayloadSchema,
  LandIqDataRunFailedPayloadSchema,
  LandIqDataRunStalePayloadSchema,
  LandIqDataRunStartedPayloadSchema,
  LandIqStageFinishedPayloadSchema,
  type LandIqDataRunFailedChunksRetriedPayload,
  type LandIqDataRunFailedPayload,
  type LandIqDataRunStalePayload,
  type LandIqDataRunStartedPayload,
  type LandIqStageFinishedPayload,
} from './admin-landiq-data-runs.events';
export { SandboxResetStartedPayloadSchema, type SandboxResetStartedPayload } from './admin-sandbox-reset.events';
export {
  SkillDefinitionLifecyclePayloadSchema,
  type SkillDefinitionLifecyclePayload,
} from './assistant-skill-definitions.events';
export {
  SkillInstanceGrantedPayloadSchema,
  SkillInstanceRevokedPayloadSchema,
  type SkillInstanceGrantedPayload,
  type SkillInstanceRevokedPayload,
} from './assistant-skill-instances.events';
export type { AdminAddedPayload, AdminDeactivatedPayload } from './admin-admins.events';
export {
  PROPERTY_CHANGE_SECTIONS,
  PROPERTY_CHANGE_SECTION_FIELDS,
  PROPERTY_CONTACT_LINK_CHANGE_FIELDS,
  AreaChangeSchema,
  PricingSaleFieldChangeSchema,
  PROPERTY_HAND_RESERVATION_CHANGES,
  PropertyActivatedPayloadSchema,
  PropertyArchivedPayloadSchema,
  PropertyAreasUpdatedPayloadSchema,
  PropertyChangeSectionSchema,
  PropertyChangeValueSchema,
  PropertyCreatedPayloadSchema,
  PropertyDeactivatedPayloadSchema,
  PropertyDeletedPayloadSchema,
  PropertyFieldChangeSchema,
  PortalListingFirstPublishedPayloadSchema,
  PortalListingBrowserTransmittedPayloadSchema,
  PortalListingBrowserLinkedPayloadSchema,
  PortalListingBrowserRunFinishedPayloadSchema,
  PortalListingBrowserRunRequestedPayloadSchema,
  PropertyPricingSaleUpdatedPayloadSchema,
  PropertySectionUpdatedPayloadSchema,
  PropertyContactLinkUpdatedPayloadSchema,
  PropertyHandReservationChangedPayloadSchema,
  PropertyStatusChangedPayloadSchema,
} from './property-properties.events';
export type {
  AreaChange,
  PricingSaleFieldChange,
  PropertyActivatedPayload,
  PropertyArchivedPayload,
  PropertyAreasUpdatedPayload,
  PropertyChangeSection,
  PropertyChangeSectionField,
  PropertyChangeValue,
  PropertyCreatedPayload,
  PropertyDeactivatedPayload,
  PropertyDeletedPayload,
  PropertyFieldChange,
  PortalListingFirstPublishedPayload,
  PortalListingBrowserTransmittedPayload,
  PortalListingBrowserRunDecidedPayload,
  PortalListingBrowserRunFinishedPayload,
  PortalListingBrowserRunRequestedPayload,
  PropertyPricingSaleUpdatedPayload,
  PropertySectionUpdatedPayload,
  PropertyContactLinkUpdatedPayload,
  PropertyHandReservationChangedPayload,
  PropertyStatusChangedPayload,
} from './property-properties.events';
export {
  PropertyDocumentAnalysisStateChangedPayloadSchema,
  PropertyDocumentBuyerSharingChangedPayloadSchema,
  PropertyDocumentClassificationOutcomeSchema,
  PropertyDocumentClassifiedPayloadSchema,
  PropertyDocumentDeletedPayloadSchema,
  PropertyDocumentRefiledPayloadSchema,
} from './property-documents.events';
export type {
  PropertyDocumentAnalysisStateChangedPayload,
  PropertyDocumentBuyerSharingChangedPayload,
  PropertyDocumentClassificationOutcome,
  PropertyDocumentClassifiedPayload,
  PropertyDocumentDeletedPayload,
  PropertyDocumentRefiledPayload,
} from './property-documents.events';
export {
  ActivityMemoryReadRequestedPayloadSchema,
  MemoryChangeViaSchema,
  MemoryEntryChangedPayloadSchema,
} from './property-memory.events';
export type {
  ActivityMemoryReadRequestedPayload,
  MemoryChangeVia,
  MemoryEntryChangedPayload,
} from './property-memory.events';
export {
  WEB_EXPOSE_WITHDRAWAL_REASONS,
  WebExposePublishedPayloadSchema,
  WebExposeWithdrawnPayloadSchema,
} from './property-web-expose.events';
export type { WebExposePublishedPayload, WebExposeWithdrawnPayload } from './property-web-expose.events';
export {
  DocumentAnalysisCompletedPayloadSchema,
  DocumentAnalysisCorrectedPayloadSchema,
  DossierBriefStalePayloadSchema,
  PropertyAgentFindingsWrittenPayloadSchema,
  PropertyFactKeyCreatedPayloadSchema,
  PropertyFactKeyRetiredPayloadSchema,
  PropertyFactKeyUpdatedPayloadSchema,
  PropertyFactsChangedPayloadSchema,
} from './property-facts.events';
export type {
  DocumentAnalysisCompletedPayload,
  DocumentAnalysisCorrectedPayload,
  DossierBriefStalePayload,
  PropertyAgentFindingsWrittenPayload,
  PropertyFactKeyCreatedPayload,
  PropertyFactKeyRetiredPayload,
  PropertyFactKeyUpdatedPayload,
  PropertyFactsChangedPayload,
} from './property-facts.events';
export {
  DEAL_ASSIGNMENT_TRIGGERS,
  DEAL_PHASE_TRIGGERS,
  DealAssignmentTriggerSchema,
  DealPhaseTriggerSchema,
  DealPhaseWalkSchema,
  DealContactAddedPayloadSchema,
  DealContactRemovedPayloadSchema,
  DealContractReceivedPayloadSchema,
  DealCreatedPayloadSchema,
  DealDeferredPayloadSchema,
  DealDeletedPayloadSchema,
  DealRestoredPayloadSchema,
  OrganizationRecordsMovedPayloadSchema,
  DealLostPayloadSchema,
  DealNotesUpdatedPayloadSchema,
  DealPhaseChangedPayloadSchema,
  DealReopenedPayloadSchema,
  DealResponsibilityChangedPayloadSchema,
  DealResumeScheduledPayloadSchema,
  DealResumedPayloadSchema,
  DealWonPayloadSchema,
} from './deal-deals.events';
export type {
  DealAssignmentTrigger,
  DealPhaseTrigger,
  DealPhaseWalk,
  DealContactAddedPayload,
  DealContactRemovedPayload,
  DealContractReceivedPayload,
  DealCreatedPayload,
  DealDeferredPayload,
  DealDeletedPayload,
  DealRestoredPayload,
  OrganizationRecordsMovedPayload,
  DealLostPayload,
  DealNotesUpdatedPayload,
  DealPhaseChangedPayload,
  DealReopenedPayload,
  DealResponsibilityChangedPayload,
  DealResumeScheduledPayload,
  DealResumedPayload,
  DealWonPayload,
} from './deal-deals.events';
export {
  BrokerageAgreementConcludedPayloadSchema,
  BrokerageConfirmationRetryDuePayloadSchema,
  BrokerageNoticeReminderDuePayloadSchema,
  BrokerageNoticeSentPayloadSchema,
  BrokerageWithdrawalReceiptRetryDuePayloadSchema,
  BrokerageWithdrawalReceiptSettledPayloadSchema,
  BrokerageEmailDeliveryCheckDuePayloadSchema,
  BrokerageWithdrawalReceivedPayloadSchema,
  BrokerageAcceptanceReplyReceivedPayloadSchema,
  BrokerageAcceptanceReminderDuePayloadSchema,
} from './deal-brokerage-agreements.events';
export type {
  BrokerageAgreementConcludedPayload,
  BrokerageConfirmationRetryDuePayload,
  BrokerageNoticeReminderDuePayload,
  BrokerageNoticeSentPayload,
  BrokerageWithdrawalReceiptRetryDuePayload,
  BrokerageWithdrawalReceiptSettledPayload,
  BrokerageEmailDeliveryCheckDuePayload,
  BrokerageWithdrawalReceivedPayload,
  BrokerageAcceptanceReplyReceivedPayload,
  BrokerageAcceptanceReminderDuePayload,
} from './deal-brokerage-agreements.events';
export {
  DataRoomDocumentAccessedPayloadSchema,
  DataRoomReleaseEndedPayloadSchema,
  DataRoomReleasedPayloadSchema,
} from './deal-data-room.events';
export type {
  DataRoomDocumentAccessedPayload,
  DataRoomReleaseEndedPayload,
  DataRoomReleasedPayload,
} from './deal-data-room.events';
export { InquiryReceivedPayloadSchema } from './deal-inquiries.events';
export type { InquiryReceivedPayload } from './deal-inquiries.events';
export {
  PROSPECT_TRIGGERS,
  ProspectCreatedPayloadSchema,
  ProspectNotaryAppointmentDateChangedPayloadSchema,
  ProspectOfferedPriceChangedPayloadSchema,
  ProspectOfferRecordedPayloadSchema,
  ProspectOfferStatusChangedPayloadSchema,
  ProspectPhaseChangedPayloadSchema,
  ProspectStatusChangedPayloadSchema,
  ProspectViewingAssessedPayloadSchema,
} from './deal-prospects.events';
export type {
  ProspectTrigger,
  ProspectCreatedPayload,
  ProspectNotaryAppointmentDateChangedPayload,
  ProspectOfferedPriceChangedPayload,
  ProspectOfferRecordedPayload,
  ProspectOfferStatusChangedPayload,
  ProspectPhaseChangedPayload,
  ProspectStatusChangedPayload,
  ProspectViewingAssessedPayload,
} from './deal-prospects.events';
export {
  SigningAcceptanceReminderDuePayloadSchema,
  SigningAcceptanceReplyMarkedPayloadSchema,
  SigningEmailDeliveryCheckDuePayloadSchema,
  SigningEmailRetryDuePayloadSchema,
  SigningProofPrunedPayloadSchema,
  SigningRevocationReceivedPayloadSchema,
  SigningRequestCompletedPayloadSchema,
  SigningRequestRemindedPayloadSchema,
  SigningRequestReminderDuePayloadSchema,
  SigningRequestSentPayloadSchema,
  SigningRequestSignedFileReadyPayloadSchema,
  SigningRequestSignerSignedPayloadSchema,
  SigningRequestWithdrawnPayloadSchema,
} from './deal-signing-requests.events';
export type {
  SigningAcceptanceReminderDuePayload,
  SigningAcceptanceReplyMarkedPayload,
  SigningEmailDeliveryCheckDuePayload,
  SigningEmailRetryDuePayload,
  SigningProofPrunedPayload,
  SigningRevocationReceivedPayload,
  SigningRequestCompletedPayload,
  SigningRequestRemindedPayload,
  SigningRequestReminderDuePayload,
  SigningRequestSentPayload,
  SigningRequestSignedFileReadyPayload,
  SigningRequestSignerSignedPayload,
  SigningRequestWithdrawnPayload,
} from './deal-signing-requests.events';
export {
  GeneratedDocumentCompletedPayloadSchema,
  GeneratedDocumentDeletedPayloadSchema,
  GeneratedDocumentFailedPayloadSchema,
  GeneratedDocumentOriginalReceivedChangedPayloadSchema,
  GeneratedDocumentRequestedPayloadSchema,
} from './deal-generated-documents.events';
export type {
  GeneratedDocumentCompletedPayload,
  GeneratedDocumentDeletedPayload,
  GeneratedDocumentFailedPayload,
  GeneratedDocumentOriginalReceivedChangedPayload,
  GeneratedDocumentRequestedPayload,
} from './deal-generated-documents.events';
export {
  ContactAddressUpdatedPayloadSchema,
  ContactCommunicationDeletedPayloadSchema,
  ContactCommunicationRecordedPayloadSchema,
  ContactCommunicationUpdatedPayloadSchema,
  ContactCreatedPayloadSchema,
  ContactDeletedPayloadSchema,
  ContactEmailsUpdatedPayloadSchema,
  ContactNoteDeletedPayloadSchema,
  ContactNoteRecordedPayloadSchema,
  ContactNoteUpdatedPayloadSchema,
  ContactPhonesUpdatedPayloadSchema,
  ContactProfileUpdatedPayloadSchema,
  ContactTypesUpdatedPayloadSchema,
  ContactWarningNoteUpdatedPayloadSchema,
} from './relationship-contacts.events';
export type {
  ContactAddressUpdatedPayload,
  ContactCommunicationDeletedPayload,
  ContactCommunicationRecordedPayload,
  ContactCommunicationUpdatedPayload,
  ContactCreatedPayload,
  ContactDeletedPayload,
  ContactEmailsUpdatedPayload,
  ContactNoteDeletedPayload,
  ContactNoteRecordedPayload,
  ContactNoteUpdatedPayload,
  ContactPhonesUpdatedPayload,
  ContactProfileUpdatedPayload,
  ContactTypesUpdatedPayload,
  ContactWarningNoteUpdatedPayload,
} from './relationship-contacts.events';
export {
  ValuationRequestCompletedPayloadSchema,
  ValuationRequestDocumentUploadedPayloadSchema,
  ValuationRequestImageUploadedPayloadSchema,
  ValuationRequestReleasedPayloadSchema,
  ValuationRequestReturnedPayloadSchema,
  ValuationRequestSubmittedForApprovalPayloadSchema,
  ValuationRequestSubmittedPayloadSchema,
  ValuationRequestTakenOnPayloadSchema,
  ValuationRequestWithdrawnPayloadSchema,
  ValuationResultAdjustedPayloadSchema,
} from './valuation-requests.events';
export type {
  ValuationRequestCompletedPayload,
  ValuationRequestDocumentUploadedPayload,
  ValuationRequestImageUploadedPayload,
  ValuationRequestReleasedPayload,
  ValuationRequestReturnedPayload,
  ValuationRequestSubmittedForApprovalPayload,
  ValuationRequestSubmittedPayload,
  ValuationRequestTakenOnPayload,
  ValuationRequestWithdrawnPayload,
  ValuationResultAdjustedPayload,
} from './valuation-requests.events';
export {
  ValuationAgentRequestDeliveredPayloadSchema,
  ValuationAgentRequestFailedPayloadSchema,
  ValuationAgentRequestOpenedPayloadSchema,
  ValuationAgentRequestTakenPayloadSchema,
} from './valuation-agent-requests.events';
export type {
  ValuationAgentRequestDeliveredPayload,
  ValuationAgentRequestFailedPayload,
  ValuationAgentRequestOpenedPayload,
  ValuationAgentRequestTakenPayload,
} from './valuation-agent-requests.events';
export { ValuationAgentResultDeliveredPayloadSchema } from './valuation-agent-results.events';
export type { ValuationAgentResultDeliveredPayload } from './valuation-agent-results.events';
export { WebhookCreatedPayloadSchema } from './webhook-webhooks.events';
export type { WebhookCreatedPayload } from './webhook-webhooks.events';
export {
  CalendarChangedPayloadSchema,
  SubscriptionResourceChangedPayloadSchema,
  CalendarEventChangedPayloadSchema,
  AppointmentLinkedPayloadSchema,
  AppointmentUnlinkedPayloadSchema,
  EmailThreadUnassignedPayloadSchema,
  EmailThreadChangedPayloadSchema,
  EmailThreadUpdatedPayloadSchema,
  MailboxChangedPayloadSchema,
  MailboxGrantExpiredPayloadSchema,
  MailboxGrantRevokedPayloadSchema,
  MessageReceivedPayloadSchema,
  MessageSendFailedPayloadSchema,
  MessageSentPayloadSchema,
  SentMessageRefSchema,
  AppointmentWrittenPayloadSchema,
  EmailThreadPlacementChangedPayloadSchema,
} from './communication-mailbox-calendar.events';
export type {
  AppointmentLinkedPayload,
  AppointmentUnlinkedPayload,
  CalendarChangedPayload,
  SubscriptionResourceChangedPayload,
  CalendarEventChangedPayload,
  EmailThreadUnassignedPayload,
  EmailThreadChangedPayload,
  EmailThreadUpdatedPayload,
  MailboxChangedPayload,
  MailboxGrantExpiredPayload,
  MailboxGrantRevokedPayload,
  MessageReceivedPayload,
  MessageSendFailedPayload,
  MessageSentPayload,
  SentMessageRef,
  AppointmentWrittenPayload,
  EmailThreadPlacementChangedPayload,
} from './communication-mailbox-calendar.events';
export {
  WhatsAppDeliveryStateChangedPayloadSchema,
  WhatsAppMemberLinkedPayloadSchema,
  WhatsAppMemberMessageRecordedPayloadSchema,
  WhatsAppMemberUnlinkedPayloadSchema,
  WhatsAppMessageReceivedPayloadSchema,
  WhatsAppStatusReportedPayloadSchema,
} from './communication-whatsapp.events';
export type {
  WhatsAppDeliveryStateChangedPayload,
  WhatsAppMemberLinkedPayload,
  WhatsAppMemberMessageRecordedPayload,
  WhatsAppMemberUnlinkedPayload,
  WhatsAppMessageReceivedPayload,
  WhatsAppStatusReportedPayload,
} from './communication-whatsapp.events';
export { TelegramMessageReceivedPayloadSchema } from './communication-telegram.events';
export type { TelegramMessageReceivedPayload } from './communication-telegram.events';
export { MessengerSessionRequestedPayloadSchema } from './communication-messenger-sessions.events';
export type { MessengerSessionRequestedPayload } from './communication-messenger-sessions.events';
export {
  MESSENGER_DISCUSSION_CONTEXT_SOURCES,
  MessengerDiscussionReceivedPayloadSchema,
  MessengerMessageReceivedPayloadSchema,
  MessengerLineSchema,
  TELEGRAM_PROVIDER_MESSAGE_ID_PREFIX,
} from './communication-messenger-inbound.events';
export type {
  MessengerDiscussionReceivedPayload,
  MessengerMessageReceivedPayload,
  MessengerLine,
} from './communication-messenger-inbound.events';
export { FleetAssistantRepliedPayloadSchema } from './fleet-assistant.events';
export type { FleetAssistantRepliedPayload } from './fleet-assistant.events';
export {
  MESSENGERS,
  MESSENGER_DISCUSSED_OUTCOME_EVENTS,
  MESSENGER_OUTCOME_EVENTS,
  MessengerOutcomeEventTypeSchema,
  MessengerOutcomePayloadSchema,
  MessengerOutcomeReplySchema,
  MessengerSchema,
} from './messenger-outcome';
export type {
  Messenger,
  MessengerOutcomeEventType,
  MessengerOutcomePayload,
  MessengerOutcomeReply,
} from './messenger-outcome';
export { CompanyMailboxLifecyclePayloadSchema } from './communication-company-mailboxes.events';
export type { CompanyMailboxLifecyclePayload } from './communication-company-mailboxes.events';
export { WhatsAppReplyProducedPayloadSchema, WhatsAppSendProposalSchema } from './assistant-whatsapp.events';
export type { WhatsAppReplyProducedPayload, WhatsAppSendProposal } from './assistant-whatsapp.events';
export {
  ActivityRecordedPayloadSchema,
  ActivityCompletedPayloadSchema,
  ActivityRescheduledPayloadSchema,
  ActivityUpdatedPayloadSchema,
  ActivityCancelledPayloadSchema,
  ActivityReassignedPayloadSchema,
  EmailActivityChangedPayloadSchema,
  EmailActivityDeletedPayloadSchema,
  EmailLastContactChangedPayloadSchema,
} from './activity-activity-records.events';
export type {
  ActivityRecordedPayload,
  ActivityCompletedPayload,
  ActivityRescheduledPayload,
  ActivityUpdatedPayload,
  ActivityCancelledPayload,
  ActivityReassignedPayload,
  EmailActivityChangedPayload,
  EmailActivityDeletedPayload,
  EmailLastContactChangedPayload,
} from './activity-activity-records.events';
export { FleetCommandIssuedPayloadSchema } from './fleet-commands.events';
export type { FleetCommandIssuedPayload } from './fleet-commands.events';
export { FleetQuestionAskedPayloadSchema } from './fleet-questions.events';
export type { FleetQuestionAskedPayload } from './fleet-questions.events';
export {
  ViewingInvitationCancelledPayloadSchema,
  ViewingInvitationRemindedPayloadSchema,
  ViewingInvitationRescheduledPayloadSchema,
  ViewingInvitationSentPayloadSchema,
  ViewingReminderDuePayloadSchema,
} from './communication-viewing-invitations.events';
export type {
  ViewingInvitationCancelledPayload,
  ViewingInvitationRemindedPayload,
  ViewingInvitationRescheduledPayload,
  ViewingInvitationSentPayload,
  ViewingReminderDuePayload,
} from './communication-viewing-invitations.events';
export { ViewingResponseChangedPayloadSchema } from './communication-viewing-responses.events';
export type { ViewingResponseChangedPayload } from './communication-viewing-responses.events';
